import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Typography, withStyles as withStyles$2, styled as styled$3, Fab, Box as Box$2, makeStyles as makeStyles$1, createStyles, Paper as Paper$2, Button, RadioGroup, Radio, FormControlLabel, Switch, Link, Divider, Backdrop, CircularProgress as CircularProgress$2, useTheme as useTheme$2, Modal, ClickAwayListener as ClickAwayListener$1 } from '@material-ui/core';
import { ToggleButtonGroup, ToggleButton, Alert } from '@material-ui/lab';
import { ChevronLeft, ChevronRight, Favorite, FavoriteBorderOutlined } from '@material-ui/icons';
import * as React$5 from 'react';
import React__default, { createContext, useState, useRef, useContext, useCallback, Children, isValidElement, cloneElement, Fragment as Fragment$1, useMemo } from 'react';
import * as ReactDOM from 'react-dom';
import ReactDOM__default from 'react-dom';
import { Link as Link$1 } from 'react-router-dom';

function ErrorText(props) {
    return (jsx(Typography, Object.assign({ variant: "body1", color: "error", paragraph: true, role: "alert" }, props, { children: props.children }), void 0));
}

const PageTitle = (props) => (jsx(Typography, Object.assign({ variant: "h1" }, props, { children: props.children }), void 0));

const IconHeader = ({ icon, children }) => (jsxs(Typography, Object.assign({ variant: "h3", style: { textTransform: 'uppercase', letterSpacing: 0.5 } }, { children: [icon, children] }), void 0));

const MiniHeader = (props) => (jsx(Typography, Object.assign({ variant: "h5" }, props, { children: props.children }), void 0));

const MiniSubHeader = (props) => (jsx(Typography, Object.assign({ variant: "h3" }, props, { children: props.children }), void 0));

const SectionHeader = (props) => (jsx(Typography, Object.assign({ variant: "h2" }, props, { children: props.children }), void 0));

const StandardText = (props) => (jsx(Typography, Object.assign({ variant: "body1" }, props, { children: props.children }), void 0));

const PreviewText = (props) => (jsx(Typography, Object.assign({ variant: "body1", style: { fontSize: 13, lineHeight: 1.33 } }, props, { children: props.children }), void 0));

const PreviewTitle = (props) => (jsx(Typography, Object.assign({ variant: "h4" }, props, { children: props.children }), void 0));

const Subtitle1 = (props) => {
    return jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: props.children }), void 0);
};

const SystemText = (props) => (jsx("i", { children: jsx(Typography, Object.assign({ variant: "body1" }, props, { children: props.children }), void 0) }, void 0));

const StyledBoolButtonGroup = withStyles$2(({ palette }) => ({
    grouped: {
        color: palette.secondary.main,
        backgroundColor: palette.common.white,
        border: `1px solid ${palette.secondary.main}`,
        '&.Mui-selected': {
            backgroundColor: palette.secondary.main,
            color: 'white',
        },
        '@media (hover: hover)': {
            '&:hover, &.Mui-selected:hover': {
                backgroundColor: palette.secondary.light,
                color: 'white',
            },
        },
        '@media (hover: none)': {
            '&.Mui-selected:hover': {
                backgroundColor: palette.secondary.main,
            },
        },
        '&:hover': {
            '@media (hover: none)': {
                backgroundColor: palette.secondary.main,
            },
        },
        '&:first-child': {
            borderRight: `2px solid ${palette.secondary.main}`,
        },
    },
}))(ToggleButtonGroup);

function PaginationBar() {
    return (jsxs(Box$2, Object.assign({ display: "flex", justifyContent: "space-between", p: 1 }, { children: [jsx(FabStyled, { children: jsx(ChevronLeft, {}, void 0) }, void 0),
            jsx(FabStyled, { children: jsx(ChevronRight, {}, void 0) }, void 0)] }), void 0));
}
const FabStyled = styled$3(Fab)({
    boxShadow: 'none',
    backgroundColor: 'white',
});

const useStyles$a = makeStyles$1(({ spacing, palette, shape }) => createStyles({
    root: {
        maxHeight: 215,
        overflowY: 'scroll',
        padding: spacing(1),
        border: `2px solid ${palette.grey[300]}`,
        textAlign: 'left',
        '&::-webkit-scrollbar': {
            width: '0.3em',
            borderRadius: 2,
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: shape.borderRadius,
        },
    },
}));
function ScrollContainer(props) {
    const styles = useStyles$a();
    return (jsx(Paper$2, Object.assign({ elevation: 0, className: styles.root, onScroll: (e) => props.scrollHandler(e) }, { children: props.children }), void 0));
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var Search = {};

var interopRequireDefault = {exports: {}};

(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;
}(interopRequireDefault));

var interopRequireWildcard = {exports: {}};

var _typeof$2 = {exports: {}};

(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;
}(_typeof$2));

(function (module) {
var _typeof = _typeof$2.exports["default"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;
module.exports["default"] = module.exports, module.exports.__esModule = true;
}(interopRequireWildcard));

var createSvgIcon$1 = {};

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}

function isPlainObject(item) {
  return item && _typeof$1(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

var propTypes = {exports: {}};

var reactIs$2 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2="function"===typeof Symbol&&Symbol.for,c$2=b$2?Symbol.for("react.element"):60103,d$2=b$2?Symbol.for("react.portal"):60106,e$1=b$2?Symbol.for("react.fragment"):60107,f$2=b$2?Symbol.for("react.strict_mode"):60108,g$2=b$2?Symbol.for("react.profiler"):60114,h$2=b$2?Symbol.for("react.provider"):60109,k$2=b$2?Symbol.for("react.context"):60110,l$2=b$2?Symbol.for("react.async_mode"):60111,m$1=b$2?Symbol.for("react.concurrent_mode"):60111,n$2=b$2?Symbol.for("react.forward_ref"):60112,p$2=b$2?Symbol.for("react.suspense"):60113,q$2=b$2?
Symbol.for("react.suspense_list"):60120,r$2=b$2?Symbol.for("react.memo"):60115,t$1=b$2?Symbol.for("react.lazy"):60116,v$2=b$2?Symbol.for("react.block"):60121,w$2=b$2?Symbol.for("react.fundamental"):60117,x$2=b$2?Symbol.for("react.responder"):60118,y$2=b$2?Symbol.for("react.scope"):60119;
function z$2(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$2:switch(a=a.type,a){case l$2:case m$1:case e$1:case g$2:case f$2:case p$2:return a;default:switch(a=a&&a.$$typeof,a){case k$2:case n$2:case t$1:case r$2:case h$2:return a;default:return u}}case d$2:return u}}}function A$2(a){return z$2(a)===m$1}reactIs_production_min$1.AsyncMode=l$2;reactIs_production_min$1.ConcurrentMode=m$1;reactIs_production_min$1.ContextConsumer=k$2;reactIs_production_min$1.ContextProvider=h$2;reactIs_production_min$1.Element=c$2;reactIs_production_min$1.ForwardRef=n$2;reactIs_production_min$1.Fragment=e$1;reactIs_production_min$1.Lazy=t$1;reactIs_production_min$1.Memo=r$2;reactIs_production_min$1.Portal=d$2;
reactIs_production_min$1.Profiler=g$2;reactIs_production_min$1.StrictMode=f$2;reactIs_production_min$1.Suspense=p$2;reactIs_production_min$1.isAsyncMode=function(a){return A$2(a)||z$2(a)===l$2};reactIs_production_min$1.isConcurrentMode=A$2;reactIs_production_min$1.isContextConsumer=function(a){return z$2(a)===k$2};reactIs_production_min$1.isContextProvider=function(a){return z$2(a)===h$2};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$2};reactIs_production_min$1.isForwardRef=function(a){return z$2(a)===n$2};reactIs_production_min$1.isFragment=function(a){return z$2(a)===e$1};reactIs_production_min$1.isLazy=function(a){return z$2(a)===t$1};
reactIs_production_min$1.isMemo=function(a){return z$2(a)===r$2};reactIs_production_min$1.isPortal=function(a){return z$2(a)===d$2};reactIs_production_min$1.isProfiler=function(a){return z$2(a)===g$2};reactIs_production_min$1.isStrictMode=function(a){return z$2(a)===f$2};reactIs_production_min$1.isSuspense=function(a){return z$2(a)===p$2};
reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$1||a===g$2||a===f$2||a===p$2||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r$2||a.$$typeof===h$2||a.$$typeof===k$2||a.$$typeof===n$2||a.$$typeof===w$2||a.$$typeof===x$2||a.$$typeof===y$2||a.$$typeof===v$2)};reactIs_production_min$1.typeOf=z$2;

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$1.AsyncMode = AsyncMode;
reactIs_development$1.ConcurrentMode = ConcurrentMode;
reactIs_development$1.ContextConsumer = ContextConsumer;
reactIs_development$1.ContextProvider = ContextProvider;
reactIs_development$1.Element = Element;
reactIs_development$1.ForwardRef = ForwardRef;
reactIs_development$1.Fragment = Fragment;
reactIs_development$1.Lazy = Lazy;
reactIs_development$1.Memo = Memo;
reactIs_development$1.Portal = Portal;
reactIs_development$1.Profiler = Profiler;
reactIs_development$1.StrictMode = StrictMode;
reactIs_development$1.Suspense = Suspense;
reactIs_development$1.isAsyncMode = isAsyncMode;
reactIs_development$1.isConcurrentMode = isConcurrentMode;
reactIs_development$1.isContextConsumer = isContextConsumer;
reactIs_development$1.isContextProvider = isContextProvider;
reactIs_development$1.isElement = isElement;
reactIs_development$1.isForwardRef = isForwardRef;
reactIs_development$1.isFragment = isFragment;
reactIs_development$1.isLazy = isLazy;
reactIs_development$1.isMemo = isMemo;
reactIs_development$1.isPortal = isPortal;
reactIs_development$1.isProfiler = isProfiler;
reactIs_development$1.isStrictMode = isStrictMode;
reactIs_development$1.isSuspense = isSuspense;
reactIs_development$1.isValidElementType = isValidElementType;
reactIs_development$1.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = reactIs_production_min$1;
} else {
  reactIs$2.exports = reactIs_development$1;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$1) {
			symbols = getOwnPropertySymbols$1(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs$2.exports;
var assign = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var checkPropTypes = checkPropTypes_1;

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$2.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

function isClassComponent$1(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent$1(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
var elementAcceptingRef$1 = elementAcceptingRef;

function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementTypeAcceptingRef$1 = chainPropTypes(propTypes.exports.elementType, elementTypeAcceptingRef);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }

  return _extends({}, propTypes, _defineProperty({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://material-ui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1=60103,c$1=60106,d$1=60107,e=60108,f$1=60114,g$1=60109,h$1=60110,k$1=60112,l$1=60113,m=60120,n$1=60115,p$1=60116,q$1=60121,r$1=60122,u$1=60117,v$1=60129,w$1=60131;
if("function"===typeof Symbol&&Symbol.for){var x$1=Symbol.for;b$1=x$1("react.element");c$1=x$1("react.portal");d$1=x$1("react.fragment");e=x$1("react.strict_mode");f$1=x$1("react.profiler");g$1=x$1("react.provider");h$1=x$1("react.context");k$1=x$1("react.forward_ref");l$1=x$1("react.suspense");m=x$1("react.suspense_list");n$1=x$1("react.memo");p$1=x$1("react.lazy");q$1=x$1("react.block");r$1=x$1("react.server.block");u$1=x$1("react.fundamental");v$1=x$1("react.debug_trace_mode");w$1=x$1("react.legacy_hidden");}
function y$1(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b$1:switch(a=a.type,a){case d$1:case f$1:case e:case l$1:case m:return a;default:switch(a=a&&a.$$typeof,a){case h$1:case k$1:case p$1:case n$1:case g$1:return a;default:return t}}case c$1:return t}}}var z$1=g$1,A$1=b$1,B$1=k$1,C=d$1,D$1=p$1,E$1=n$1,F$1=c$1,G$1=f$1,H$1=e,I$1=l$1;reactIs_production_min.ContextConsumer=h$1;reactIs_production_min.ContextProvider=z$1;reactIs_production_min.Element=A$1;reactIs_production_min.ForwardRef=B$1;reactIs_production_min.Fragment=C;reactIs_production_min.Lazy=D$1;reactIs_production_min.Memo=E$1;reactIs_production_min.Portal=F$1;reactIs_production_min.Profiler=G$1;reactIs_production_min.StrictMode=H$1;
reactIs_production_min.Suspense=I$1;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return y$1(a)===h$1};reactIs_production_min.isContextProvider=function(a){return y$1(a)===g$1};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$1};reactIs_production_min.isForwardRef=function(a){return y$1(a)===k$1};reactIs_production_min.isFragment=function(a){return y$1(a)===d$1};reactIs_production_min.isLazy=function(a){return y$1(a)===p$1};reactIs_production_min.isMemo=function(a){return y$1(a)===n$1};
reactIs_production_min.isPortal=function(a){return y$1(a)===c$1};reactIs_production_min.isProfiler=function(a){return y$1(a)===f$1};reactIs_production_min.isStrictMode=function(a){return y$1(a)===e};reactIs_production_min.isSuspense=function(a){return y$1(a)===l$1};reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d$1||a===f$1||a===v$1||a===e||a===l$1||a===m||a===w$1||"object"===typeof a&&null!==a&&(a.$$typeof===p$1||a.$$typeof===n$1||a.$$typeof===g$1||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===u$1||a.$$typeof===q$1||a[0]===r$1)?!0:!1};
reactIs_production_min.typeOf=y$1;

var reactIs_development = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (_typeof$1(Component) === 'object') {
    switch (Component.$$typeof) {
      case reactIs$1.exports.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case reactIs$1.exports.Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

var refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
var refType$1 = refType;

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : formatMuiErrorMessage(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (typeof func !== 'function') {
        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
      }
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (process.env.NODE_ENV !== 'production') {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (process.env.NODE_ENV === 'production') {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += '\n';
            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += '\n';
          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += '\n';
      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "\n" + result + "\n";
  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.key = void 0;
    this.isProcessed = false;
    this.style = void 0;
    this.renderer = void 0;
    this.renderable = void 0;
    this.options = void 0;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
      process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    _this.selectorText = void 0;
    _this.id = void 0;
    _this.renderable = void 0;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  _createClass(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(name, style, options) {
    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(name, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.at = void 0;
    this.key = void 0;
    this.query = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {\n" + children + "\n}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.key = void 0;
    this.name = void 0;
    this.id = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "\n" + children + "\n";
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp$1 = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp$1, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var plugin = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
    _this.renderable = void 0;
    return _this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += '\n';
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.key = void 0;
    this.value = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins$1 = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = _extends({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Get a rule.
   */
  ;

  _proto.get = function get(name) {
    return this.map[name];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.map[name], data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var styleRule = rule;
    var style = styleRule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== styleRule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.

      for (var prop in styleRule.style) {
        var nextValue = styleRule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          styleRule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = styleRule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          styleRule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += '\n';
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.options = void 0;
    this.deployed = void 0;
    this.attached = void 0;
    this.rules = void 0;
    this.renderer = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.queue = void 0;
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name.
   */
  ;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = void 0;
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      // $FlowFixMe[prop-missing]
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
          process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = _objectWithoutPropertiesLoose(_ref, ["attached"]);

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += '\n';
      css += sheet.toString(options);
    }

    return css;
  };

  _createClass(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var registry = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */
var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;
  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };
};

/**
 * Cache the value from the first time a function is called.
 */
var memoize$1 = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};

/**
 * Set a style property.
 */
var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};

/**
 * Remove a style property.
 */
var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};

/**
 * Set the selector.
 */
var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize$1(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry$1 = registry.registry;

  if (registry$1.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize$1(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      var c = container;
      c.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        var _c = container;

        _c.appendRule(rule);
      }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.element = void 0;
    this.sheet = void 0;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) registry.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules[index] = cssRule;
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.6.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins$1.length; i++) {
      this.plugins.use(plugins$1[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = _extends({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = registry.index === 0 ? 0 : registry.index + 1;
    }

    var sheet = new StyleSheet(styles, _extends({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    registry.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      // $FlowFixMe[incompatible-call]
      return this.createRule(undefined, name, style);
    } // $FlowFixMe[incompatible-type]


    var ruleOptions = _extends({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */

/**
 * Export a constant indicating if this browser has CSSTOM support.
 * https://developers.google.com/web/updates/2018/03/cssom
 */
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Creates a new instance of Jss.
 */

var create = function create(options) {
  return new Jss(options);
};
/**
 * A global Jss instance.
 */

create();

var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      } // $FlowFixMe[prop-missing]


      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule; // $FlowFixMe[prop-missing]

      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (process.env.NODE_ENV === 'development') {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      } // $FlowFixMe[prop-missing]


      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var functions = functionPlugin;

var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.rules = void 0;
    this.options = void 0;
    this.key = void 0;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString() {
    return this.rules.toString();
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.options = void 0;
    this.rule = void 0;
    this.isProcessed = false;
    this.key = void 0;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp$1 = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp$1);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        rule = rule;
        return rule.selector;
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return _extends({}, prevOptions, {
      index: prevOptions.index + 1 // $FlowFixMe[prop-missing]

    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        container.addRule(selector, style[prop], _extends({}, options, {
          selector: selector
        }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
        // And flow doesn't know this will always be a StyleRule which has the addRule method
        // $FlowFixMe[incompatible-use]
        // $FlowFixMe[prop-missing]
        .addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$2 = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache$2.hasOwnProperty(name)) {
    return cache$2[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache$2[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 *
 * @type object
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var _key in obj) {
    newObj[_key] = obj[_key];
    newObj[_key.replace(regExp, replace)] = obj[_key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

// Export javascript style and css style vendor prefixes.
var js = '';
var css$1 = '';
var vendor = '';
var browser = '';
var isTouch = isBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (isBrowser) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style$1 = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style$1) {
      js = key;
      css$1 = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style$1) {
    js = 'ms';
    css$1 = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style$1) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css$1,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform$1 = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform$1, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (isBrowser) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (isBrowser) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}

/**
 * Add vendor prefix to a property name when needed.
 *
 * @api public
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

function jssPreset() {
  return {
    plugins: [functions(), jssGlobal(), jssNested(), camelCase(), defaultUnit(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = _extends({}, baseClasses);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
var multiKeyStore$1 = multiKeyStore;

var ThemeContext$1 = React__default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ThemeContext$1.displayName = 'ThemeContext';
}

var ThemeContext$2 = ThemeContext$1;

function useTheme$1() {
  var theme = React__default.useContext(ThemeContext$2);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__default.useDebugValue(theme);
  }

  return theme;
}

var jss = create(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName$1 = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName$1,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React__default.createContext(defaultOptions);

if (process.env.NODE_ENV !== 'production') {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = _objectWithoutProperties(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = React__default.useContext(StylesContext);

  var context = _extends({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = create({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/React__default.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (process.env.NODE_ENV !== 'production') {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
var noopTheme$1 = noopTheme;

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (process.env.NODE_ENV !== 'production') {
    if (_typeof$1(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          if (themingEnabled === true && theme === noopTheme$1) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = _extends({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (process.env.NODE_ENV !== 'production') {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore$1.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = _extends({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore$1.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        multiKeyStore$1.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    multiKeyStore$1.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = React__default.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = React__default.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  React__default.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? noopTheme$1 : _options$defaultTheme,
      stylesOptions2 = _objectWithoutProperties(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme$1() || defaultTheme;

    var stylesOptions = _extends({}, React__default.useContext(StylesContext), stylesOptions2);

    var instance = React__default.useRef();
    var shouldUpdate = React__default.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React__default.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__default.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

var reactIs = reactIs$2.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function omit$1(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
} // styled-components's API removes the mapping between components and styles.
// Using components as a low-level styling construct can be simpler.


function styled$2(Component) {
  var componentCreator = function componentCreator(style) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var name = options.name,
        stylesOptions = _objectWithoutProperties(options, ["name"]);

    if (process.env.NODE_ENV !== 'production' && Component === undefined) {
      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
    }

    var classNamePrefix = name;

    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var stylesOrCreator = typeof style === 'function' ? function (theme) {
      return {
        root: function root(props) {
          return style(_extends({
            theme: theme
          }, props));
        }
      };
    } : {
      root: style
    };
    var useStyles = makeStyles(stylesOrCreator, _extends({
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var filterProps;
    var propTypes = {};

    if (style.filterProps) {
      filterProps = style.filterProps;
      delete style.filterProps;
    }
    /* eslint-disable react/forbid-foreign-prop-types */


    if (style.propTypes) {
      propTypes = style.propTypes;
      delete style.propTypes;
    }
    /* eslint-enable react/forbid-foreign-prop-types */


    var StyledComponent = /*#__PURE__*/React__default.forwardRef(function StyledComponent(props, ref) {
      var children = props.children,
          classNameProp = props.className,
          clone = props.clone,
          ComponentProp = props.component,
          other = _objectWithoutProperties(props, ["children", "className", "clone", "component"]);

      var classes = useStyles(props);
      var className = clsx(classes.root, classNameProp);
      var spread = other;

      if (filterProps) {
        spread = omit$1(spread, filterProps);
      }

      if (clone) {
        return /*#__PURE__*/React__default.cloneElement(children, _extends({
          className: clsx(children.props.className, className)
        }, spread));
      }

      if (typeof children === 'function') {
        return children(_extends({
          className: className
        }, spread));
      }

      var FinalComponent = ComponentProp || Component;
      return /*#__PURE__*/React__default.createElement(FinalComponent, _extends({
        ref: ref,
        className: className
      }, spread), children);
    });
    process.env.NODE_ENV !== "production" ? StyledComponent.propTypes = _extends({
      /**
       * A render function or node.
       */
      children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

      /**
       * @ignore
       */
      className: PropTypes.string,

      /**
       * If `true`, the component will recycle it's children HTML element.
       * It's using `React.cloneElement` internally.
       *
       * This prop will be deprecated and removed in v5
       */
      clone: chainPropTypes(PropTypes.bool, function (props) {
        if (props.clone && props.component) {
          return new Error('You can not use the clone and component prop at the same time.');
        }

        return null;
      }),

      /**
       * The component used for the root node.
       * Either a string to use a HTML element or a component.
       */
      component: PropTypes
      /* @typescript-to-proptypes-ignore */
      .elementType
    }, propTypes) : void 0;

    if (process.env.NODE_ENV !== 'production') {
      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
    }

    hoistNonReactStatics_cjs(StyledComponent, Component);
    return StyledComponent;
  };

  return componentCreator;
}

// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles$1 = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = _objectWithoutProperties(options, ["defaultTheme", "withTheme", "name"]);

    if (process.env.NODE_ENV !== 'production') {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = makeStyles(stylesOrCreator, _extends({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/React__default.forwardRef(function WithStyles(props, ref) {
      props.classes;
          var innerRef = props.innerRef,
          other = _objectWithoutProperties(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(_extends({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = useTheme$1() || defaultTheme;

        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/React__default.createElement(Component, _extends({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
    process.env.NODE_ENV !== "production" ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (process.env.NODE_ENV !== 'production') {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    hoistNonReactStatics_cjs(WithStyles, Component);

    if (process.env.NODE_ENV !== 'production') {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

var withStylesWithoutDefault = withStyles$1;

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = _objectWithoutProperties(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return _extends({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return _extends({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return _extends({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, _defineProperty({}, breakpoints.up('sm'), _extends({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

var common = {
  black: '#000',
  white: '#fff'
};
var common$1 = common;

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var grey$1 = grey;

var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var indigo$1 = indigo;

var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var pink$1 = pink;

var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var red$1 = red;

var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var orange$1 = orange;

var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var blue$1 = blue;

var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var green$1 = green;

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : formatMuiErrorMessage(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    default: grey$1[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common$1.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey$1[800],
    default: '#303030'
  },
  action: {
    active: common$1.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo$1[300],
    main: indigo$1[500],
    dark: indigo$1[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink$1.A200,
    main: pink$1.A400,
    dark: pink$1.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red$1[300],
    main: red$1[500],
    dark: red$1[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange$1[300],
    main: orange$1[500],
    dark: orange$1[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue$1[300],
    main: blue$1[500],
    dark: blue$1[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green$1[300],
    main: green$1[500],
    dark: green$1[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = _objectWithoutProperties(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (process.env.NODE_ENV !== 'production') {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : formatMuiErrorMessage(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createMuiTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createMuiTheme({ palette: {\n  primary: { main: green[500] },\n} });") : formatMuiErrorMessage(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (process.env.NODE_ENV !== 'production') {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = deepmerge(_extends({
    // A collection of common colors.
    common: common$1,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows$1 = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$2 = shadows$1;

var shape = {
  borderRadius: 4
};
var shape$1 = shape;

var responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
var responsivePropType$1 = responsivePropType;

function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return deepmerge(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

// For instance with the first breakpoint xs: [xs, sm[.

var values$1 = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values$1[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (process.env.NODE_ENV !== 'production') {
    if (!props.theme) {
      console.error('Material-UI: You are calling a style function without a theme value.');
    }
  }

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (_typeof$1(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function getPath(obj, path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  return path.split('.').reduce(function (acc, item) {
    return acc && acc[item] ? acc[item] : null;
  }, obj);
}

function style(options) {
  var prop = options.prop,
      _options$cssProperty = options.cssProperty,
      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
      themeKey = options.themeKey,
      transform = options.transform;

  var fn = function fn(props) {
    if (props[prop] == null) {
      return null;
    }

    var propValue = props[prop];
    var theme = props.theme;
    var themeMapping = getPath(theme, themeKey) || {};

    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
      var value;

      if (typeof themeMapping === 'function') {
        value = themeMapping(propValueFinal);
      } else if (Array.isArray(themeMapping)) {
        value = themeMapping[propValueFinal] || propValueFinal;
      } else {
        value = getPath(themeMapping, propValueFinal) || propValueFinal;

        if (transform) {
          value = transform(value);
        }
      }

      if (cssProperty === false) {
        return value;
      }

      return _defineProperty({}, cssProperty, value);
    };

    return handleBreakpoints(props, propValue, styleFromPropValue);
  };

  fn.propTypes = process.env.NODE_ENV !== 'production' ? _defineProperty({}, prop, responsivePropType$1) : {};
  fn.filterProps = [prop];
  return fn;
}

function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var fn = function fn(props) {
    return styles.reduce(function (acc, style) {
      var output = style(props);

      if (output) {
        return merge(acc, output);
      }

      return acc;
    }, {});
  }; // Alternative approach that doesn't yield any performance gain.
  // const handlers = styles.reduce((acc, style) => {
  //   style.filterProps.forEach(prop => {
  //     acc[prop] = style;
  //   });
  //   return acc;
  // }, {});
  // const fn = props => {
  //   return Object.keys(props).reduce((acc, prop) => {
  //     if (handlers[prop]) {
  //       return merge(acc, handlers[prop](props));
  //     }
  //     return acc;
  //   }, {});
  // };


  fn.propTypes = process.env.NODE_ENV !== 'production' ? styles.reduce(function (acc, style) {
    return _extends(acc, style.propTypes);
  }, {}) : {};
  fn.filterProps = styles.reduce(function (acc, style) {
    return acc.concat(style.filterProps);
  }, []);
  return fn;
}

function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return "".concat(value, "px solid");
}

var border = style({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
var borderTop = style({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
var borderRight = style({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
var borderBottom = style({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
var borderLeft = style({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
var borderColor = style({
  prop: 'borderColor',
  themeKey: 'palette'
});
var borderRadius = style({
  prop: 'borderRadius',
  themeKey: 'shape'
});
var borders = compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
var borders$1 = borders;

function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}

function css(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var output = styleFunction(props);

    if (props.css) {
      return _extends({}, merge(output, styleFunction(_extends({
        theme: props.theme
      }, props.css))), omit(props.css, [styleFunction.filterProps]));
    }

    return output;
  };

  newStyleFunction.propTypes = process.env.NODE_ENV !== 'production' ? _extends({}, styleFunction.propTypes, {
    css: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['css'].concat(_toConsumableArray(styleFunction.filterProps));
  return newStyleFunction;
}

var displayPrint = style({
  prop: 'displayPrint',
  cssProperty: false,
  transform: function transform(value) {
    return {
      '@media print': {
        display: value
      }
    };
  }
});
var displayRaw = style({
  prop: 'display'
});
var overflow = style({
  prop: 'overflow'
});
var textOverflow = style({
  prop: 'textOverflow'
});
var visibility = style({
  prop: 'visibility'
});
var whiteSpace = style({
  prop: 'whiteSpace'
});
var display = compose(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);

var flexBasis = style({
  prop: 'flexBasis'
});
var flexDirection = style({
  prop: 'flexDirection'
});
var flexWrap = style({
  prop: 'flexWrap'
});
var justifyContent = style({
  prop: 'justifyContent'
});
var alignItems = style({
  prop: 'alignItems'
});
var alignContent = style({
  prop: 'alignContent'
});
var order = style({
  prop: 'order'
});
var flex = style({
  prop: 'flex'
});
var flexGrow = style({
  prop: 'flexGrow'
});
var flexShrink = style({
  prop: 'flexShrink'
});
var alignSelf = style({
  prop: 'alignSelf'
});
var justifyItems = style({
  prop: 'justifyItems'
});
var justifySelf = style({
  prop: 'justifySelf'
});
var flexbox = compose(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
var flexbox$1 = flexbox;

var gridGap = style({
  prop: 'gridGap'
});
var gridColumnGap = style({
  prop: 'gridColumnGap'
});
var gridRowGap = style({
  prop: 'gridRowGap'
});
var gridColumn = style({
  prop: 'gridColumn'
});
var gridRow = style({
  prop: 'gridRow'
});
var gridAutoFlow = style({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = style({
  prop: 'gridAutoColumns'
});
var gridAutoRows = style({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = style({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = style({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = style({
  prop: 'gridTemplateAreas'
});
var gridArea = style({
  prop: 'gridArea'
});
var grid = compose(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
var grid$1 = grid;

var color = style({
  prop: 'color',
  themeKey: 'palette'
});
var bgcolor = style({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
var palette = compose(color, bgcolor);
var palette$1 = palette;

var position = style({
  prop: 'position'
});
var zIndex$2 = style({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
var top = style({
  prop: 'top'
});
var right = style({
  prop: 'right'
});
var bottom = style({
  prop: 'bottom'
});
var left = style({
  prop: 'left'
});
var positions = compose(position, zIndex$2, top, right, bottom, left);

var boxShadow = style({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
var shadows = boxShadow;

function transform(value) {
  return value <= 1 ? "".concat(value * 100, "%") : value;
}

var width = style({
  prop: 'width',
  transform: transform
});
var maxWidth = style({
  prop: 'maxWidth',
  transform: transform
});
var minWidth = style({
  prop: 'minWidth',
  transform: transform
});
var height = style({
  prop: 'height',
  transform: transform
});
var maxHeight = style({
  prop: 'maxHeight',
  transform: transform
});
var minHeight = style({
  prop: 'minHeight',
  transform: transform
});
style({
  prop: 'size',
  cssProperty: 'width',
  transform: transform
});
style({
  prop: 'size',
  cssProperty: 'height',
  transform: transform
});
var boxSizing = style({
  prop: 'boxSizing'
});
var sizing = compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
var sizing$1 = sizing;

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = memoize(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = _slicedToArray(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return handleBreakpoints(props, propValue, styleFromPropValue);
  }).reduce(merge, {});
}

spacing.propTypes = process.env.NODE_ENV !== 'production' ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;

var fontFamily = style({
  prop: 'fontFamily',
  themeKey: 'typography'
});
var fontSize = style({
  prop: 'fontSize',
  themeKey: 'typography'
});
var fontStyle = style({
  prop: 'fontStyle',
  themeKey: 'typography'
});
var fontWeight = style({
  prop: 'fontWeight',
  themeKey: 'typography'
});
var letterSpacing = style({
  prop: 'letterSpacing'
});
var lineHeight = style({
  prop: 'lineHeight'
});
var textAlign = style({
  prop: 'textAlign'
});
var typography = compose(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
var typography$1 = typography;

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = createUnarySpacing({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = _objectWithoutProperties(options, ["duration", "easing", "delay"]);

    if (process.env.NODE_ENV !== 'production') {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;

function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = _objectWithoutProperties(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: shadows$2,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape$1,
    transitions: transitions,
    zIndex: zIndex$1
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);

  if (process.env.NODE_ENV !== 'production') {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

var defaultTheme = createMuiTheme();
var defaultTheme$1 = defaultTheme;

function withStyles(stylesOrCreator, options) {
  return withStylesWithoutDefault(stylesOrCreator, _extends({
    defaultTheme: defaultTheme$1
  }, options));
}

var styles$8 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/React$5.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/React$5.createElement(Component, _extends({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], fontSize !== 'default' && classes["fontSize".concat(capitalize(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/React$5.createElement("title", null, titleAccess) : null);
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: PropTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: PropTypes.oneOf(['default', 'inherit', 'large', 'small']),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: PropTypes.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = withStyles(styles$8, {
  name: 'MuiSvgIcon'
})(SvgIcon);

/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/React__default.createElement(SvgIcon$1, _extends({
      ref: ref
    }, props), path);
  };

  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/React__default.memo( /*#__PURE__*/React__default.forwardRef(Component));
}

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

function deprecatedPropType(validator, reason) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/React$5.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}

function requirePropFactory(componentNameInError) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = React$5.useRef(controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = React$5.useState(defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (process.env.NODE_ENV !== 'production') {
    React$5.useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [controlled]);

    var _React$useRef2 = React$5.useRef(defaultProp),
        defaultValue = _React$useRef2.current;

    React$5.useEffect(function () {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }

  var setValueIfUncontrolled = React$5.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

var useEnhancedEffect$1 = typeof window !== 'undefined' ? React$5.useLayoutEffect : React$5.useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = React$5.useRef(fn);
  useEnhancedEffect$1(function () {
    ref.current = fn;
  });
  return React$5.useCallback(function () {
    return (ref.current).apply(void 0, arguments);
  }, []);
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return React$5.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = React$5.useState(idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  React$5.useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = React$5.useCallback(function (instance) {
    var node = ReactDOM.findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$5.useDebugValue(isFocusVisible);
  }

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  capitalize: capitalize,
  createChainedFunction: createChainedFunction,
  createSvgIcon: createSvgIcon,
  debounce: debounce,
  deprecatedPropType: deprecatedPropType,
  isMuiElement: isMuiElement,
  ownerDocument: ownerDocument,
  ownerWindow: ownerWindow,
  requirePropFactory: requirePropFactory,
  setRef: setRef,
  unsupportedProp: unsupportedProp,
  useControlled: useControlled,
  useEventCallback: useEventCallback,
  useForkRef: useForkRef,
  unstable_useId: useId,
  useIsFocusVisible: useIsFocusVisible
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(utils);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
});

var _utils = require$$0;
}(createSvgIcon$1));

var _interopRequireDefault$4 = interopRequireDefault.exports;

var _interopRequireWildcard$4 = interopRequireWildcard.exports;

Object.defineProperty(Search, "__esModule", {
  value: true
});
var default_1$4 = Search.default = void 0;

var React$4 = _interopRequireWildcard$4(React__default);

var _createSvgIcon$4 = _interopRequireDefault$4(createSvgIcon$1);

var _default$4 = (0, _createSvgIcon$4.default)( /*#__PURE__*/React$4.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

default_1$4 = Search.default = _default$4;

var Tune = {};

var _interopRequireDefault$3 = interopRequireDefault.exports;

var _interopRequireWildcard$3 = interopRequireWildcard.exports;

Object.defineProperty(Tune, "__esModule", {
  value: true
});
var default_1$3 = Tune.default = void 0;

var React$3 = _interopRequireWildcard$3(React__default);

var _createSvgIcon$3 = _interopRequireDefault$3(createSvgIcon$1);

var _default$3 = (0, _createSvgIcon$3.default)( /*#__PURE__*/React$3.createElement("path", {
  d: "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
}), 'Tune');

default_1$3 = Tune.default = _default$3;

const useStyles$9 = makeStyles$1(({ spacing, palette }) => createStyles({
    container: {
        width: '100%',
        padding: spacing(1),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: palette.primary.main,
    },
    searchGroup: {
        position: 'relative',
        '--icon-size': '24px',
        '& input': {
            height: '1.9em',
            border: 'none',
            borderRadius: '11px',
            outline: 'none',
            background: 'rgba(255, 255, 255, 0.77)',
            paddingLeft: 'calc(var(--icon-size) * 1.4)',
        },
        '& .searchIconBox': {
            position: 'absolute',
            top: '2px',
            left: 'calc(var(--icon-size) / 4)',
            display: 'flex',
            alignItems: 'center',
            '& .searchIcon': {
                color: '#ffffff',
            },
        },
    },
    controls: {
        display: 'flex',
        lineHeight: 1,
        color: '#ffffff',
        '& .preferences': {
            cursor: 'pointer',
        },
        '& .favorite': {
            cursor: 'pointer',
        },
        '& > * + *': {
            marginLeft: 3,
        },
    },
}));
function SearchBox({ searchContent, onChangeSearchContent, onClickPreferences, onClickFavorite, favoritesOnly, extraButtons, }) {
    const styles = useStyles$9();
    return (jsxs(Box$2, Object.assign({ className: styles.container }, { children: [jsxs(Box$2, Object.assign({ className: styles.searchGroup }, { children: [jsx("input", { type: "text", className: "searchField", value: searchContent, onChange: (ev) => onChangeSearchContent(ev.target.value) }, void 0),
                    jsx(Box$2, Object.assign({ className: "searchIconBox" }, { children: jsx(default_1$4, { className: "searchIcon" }, void 0) }), void 0)] }), void 0),
            jsxs(Box$2, Object.assign({ className: styles.controls }, { children: [jsx(Box$2, Object.assign({ className: "preferences", onClick: onClickPreferences }, { children: jsx(default_1$3, {}, void 0) }), void 0),
                    jsx(Box$2, Object.assign({ className: "favorite", onClick: onClickFavorite }, { children: favoritesOnly ? jsx(Favorite, {}, void 0) : jsx(FavoriteBorderOutlined, {}, void 0) }), void 0),
                    extraButtons && jsx(Box$2, { children: extraButtons() }, void 0)] }), void 0)] }), void 0));
}

const useStyles$8 = makeStyles$1(({ palette, spacing, shape }) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        '& button': {
            marginBottom: spacing(1),
        },
    },
    styledButton: {
        padding: spacing(1, 2),
        color: 'white',
        width: '100%',
        border: 'none',
        textTransform: 'uppercase',
        backgroundColor: palette.primary.main,
        boxShadow: '0 5px 5px rgba(0,0,0,.2), 0 8px 10px rgba(0,0,0,.14), 0 3px 14px rgba(0,0,0,.12)',
        '&.Mui-selected': {
            backgroundColor: palette.primary.dark,
            color: 'white',
        },
        '@media (hover: hover)': {
            '&:hover, &.Mui-selected:hover': {
                backgroundColor: palette.primary.light,
            },
        },
        '@media (hover: none)': {
            '&.Mui-selected:hover': {
                backgroundColor: palette.primary.dark,
            },
        },
        '&:hover': {
            '@media (hover: none)': {
                backgroundColor: palette.primary.main,
            },
        },
        '&:not(:first-child)': {
            borderRadius: shape.borderRadius,
        },
        '&:first-child': {
            borderRadius: shape.borderRadius,
        },
        '& .MuiToggleButton-label': {
            fontWeight: 700,
        },
    },
}));
const StyledButtonGroup = React__default.forwardRef((props, ref) => {
    const styles = useStyles$8();
    const { value, buttonValues, onChange, title, disabled, exclusive } = props;
    const buttons = [];
    for (const label in buttonValues) {
        buttons.push(jsx(ToggleButton, Object.assign({ value: buttonValues[label], "aria-label": label, className: styles.styledButton, disabled: disabled }, { children: label }), label));
    }
    return (jsx(ToggleButtonGroup, Object.assign({ value: value, onChange: onChange, "aria-label": title, className: styles.root, exclusive: exclusive, ref: ref }, { children: buttons }), void 0));
});

const useStyles$7 = makeStyles$1({
    label: {
        fontWeight: 700,
        fontSize: 15,
        lineHeight: 1,
        textTransform: 'uppercase',
    },
});
function ButtonSmall(props) {
    const { label } = useStyles$7();
    return (jsx(Button, Object.assign({ size: "small", variant: "contained", color: "primary", classes: { label } }, props, { children: props.children }), void 0));
}

function ButtonMedium(props) {
    return (jsx(Button, Object.assign({ size: "medium", variant: "contained", color: "primary" }, props, { children: props.children }), void 0));
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const useStyles$6 = makeStyles$1({
    label: {
        fontWeight: 700,
        fontSize: 15,
        lineHeight: 1,
        textTransform: 'initial',
    },
    uppercaseLabel: {
        fontWeight: 700,
        fontSize: 15,
        lineHeight: 1,
        textTransform: 'uppercase',
    },
    buttonStyles: {
        paddingTop: '1em',
        paddingBottom: '1em',
    },
});
function ButtonLarge(props) {
    const { label, buttonStyles, uppercaseLabel } = useStyles$6();
    const { isUppercase } = props, buttonProps = __rest(props, ["isUppercase"]);
    return (jsx(Button, Object.assign({ size: "large", variant: "contained", color: "primary", className: buttonStyles }, buttonProps, { classes: Object.assign(Object.assign({}, props.classes), { label: isUppercase ? uppercaseLabel : label }) }, { children: props.children }), void 0));
}

const useStyles$5 = makeStyles$1({
    label: {
        fontWeight: 700,
        fontSize: 15,
        lineHeight: 1,
        textTransform: 'initial',
    },
    uppercaseLabel: {
        fontWeight: 700,
        fontSize: 15,
        lineHeight: 1,
        textTransform: 'uppercase',
    },
    buttonStyles: {
        paddingTop: '1em',
        paddingBottom: '1em',
        background: '#F0F0F4',
        '&:hover': {
            background: '#E0E0E4',
        },
    },
});
function ButtonLargeSecondary(props) {
    var _a;
    const { label, buttonStyles, uppercaseLabel } = useStyles$5();
    const isUppercase = (_a = props.isUppercase) !== null && _a !== void 0 ? _a : true;
    return (jsx(Button, Object.assign({ size: "large", variant: "contained", color: "secondary", className: buttonStyles }, props, { classes: Object.assign(Object.assign({}, props.classes), { label: isUppercase ? uppercaseLabel : label }) }, { children: props.children }), void 0));
}

const ButtonFullWidthSecondary = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (jsx(StyledButton, Object.assign({ variant: "contained", disableElevation: true, size: "small" }, rest, { children: children }), void 0));
};
const StyledButton = styled$3(Button)(({ theme }) => ({
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.divider,
    width: '100%',
    textTransform: 'none',
    height: '32px',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '15px',
    marginBottom: '1rem',
    marginTop: '1rem',
}));

var Check = {};

var _interopRequireDefault$2 = interopRequireDefault.exports;

var _interopRequireWildcard$2 = interopRequireWildcard.exports;

Object.defineProperty(Check, "__esModule", {
  value: true
});
var default_1$2 = Check.default = void 0;

var React$2 = _interopRequireWildcard$2(React__default);

var _createSvgIcon$2 = _interopRequireDefault$2(createSvgIcon$1);

var _default$2 = (0, _createSvgIcon$2.default)( /*#__PURE__*/React$2.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

default_1$2 = Check.default = _default$2;

const useStyles$4 = makeStyles$1(() => createStyles({
    buttonContainer: {
        background: '#4CAF50',
        borderRadius: '4px',
        color: '#ffffff',
        padding: '10px 30px',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '15px',
        textTransform: 'none',
        '& .MuiSvgIcon-root': {
            fontSize: '14px',
        },
        '&:hover': {
            background: '#9EAF50',
        },
    },
}));
const ButtonAcceptCR = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const classes = useStyles$4();
    return (jsxs(Button, Object.assign({ className: classes.buttonContainer }, props, { children: [jsx(default_1$2, {}, void 0),
            jsx(Box$2, Object.assign({ ml: 1 }, { children: children || 'Accept' }), void 0)] }), void 0));
};

var Clear = {};

var _interopRequireDefault$1 = interopRequireDefault.exports;

var _interopRequireWildcard$1 = interopRequireWildcard.exports;

Object.defineProperty(Clear, "__esModule", {
  value: true
});
var default_1$1 = Clear.default = void 0;

var React$1 = _interopRequireWildcard$1(React__default);

var _createSvgIcon$1 = _interopRequireDefault$1(createSvgIcon$1);

var _default$1 = (0, _createSvgIcon$1.default)( /*#__PURE__*/React$1.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

default_1$1 = Clear.default = _default$1;

const useStyles$3 = makeStyles$1(() => createStyles({
    buttonContainer: {
        background: '#F88078',
        borderRadius: '4px',
        color: '#ffffff',
        padding: '10px 30px',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '15px',
        textTransform: 'none',
        '& .MuiSvgIcon-root': {
            fontSize: '14px',
        },
        '&:hover': {
            background: '#F88098',
        },
    },
}));
const ButtonDeleteCR = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const classes = useStyles$3();
    return (jsxs(Button, Object.assign({ className: classes.buttonContainer }, props, { children: [jsx(default_1$1, {}, void 0),
            jsx(Box$2, Object.assign({ ml: 1 }, { children: children || 'Delete' }), void 0)] }), void 0));
};

const useStyles$2 = makeStyles$1((theme) => createStyles({
    buttonContainer: {
        textTransform: 'none',
        background: '#F88078',
        color: theme.palette.common.white,
        padding: '4px 10px 4px 10px',
        borderRadius: '4px',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '15px',
        '&:hover': {
            background: '#FB8098',
        },
        '&.Mui-disabled': {
            color: '#cccccc',
        },
    },
}));
const ActionButton = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const classes = useStyles$2();
    return (jsx(Button, Object.assign({ className: classes.buttonContainer }, props, { children: children }), void 0));
};

const InputSelectRadioPills = ({ name, options, value, onChange }) => {
    const style = {
        flexBasis: `${Math.floor(100 / options.length) - 1}%`,
    };
    return (jsx(Fragment, { children: jsx(StyledRadioGroup, Object.assign({ name: name, onChange: onChange, value: value }, { children: options.map((o) => (jsx(StyledRadio, { value: o.id, icon: o.title, checkedIcon: o.title, style: style }, o.id))) }), void 0) }, void 0));
};
const StyledRadioGroup = styled$3(RadioGroup)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
});
const StyledRadio = styled$3(Radio)(({ theme: { palette } }) => ({
    borderRadius: '5px',
    backgroundColor: 'rgba(43, 39, 97, 0.07)',
    transition: 'background-color .1s',
    color: '#8C8AAC',
    height: 50,
    '&:hover': {
        backgroundColor: palette.primary.dark,
        color: palette.type === 'light' ? palette.common.white : palette.common.black,
        transition: 'background-color .1s',
    },
    '& .MuiIconButton-label': {
        display: 'flex',
    },
    '&.Mui-checked.MuiButtonBase-root': {
        backgroundColor: palette.primary.main,
        transition: 'background-color .1s',
        color: palette.type === 'light' ? palette.common.white : palette.common.black,
    },
}));

const InputToggle = (_a) => {
    var { name, label } = _a, rest = __rest(_a, ["name", "label"]);
    return (jsx(Fragment, { children: jsx(FormControlLabel, { control: jsx(Switch, Object.assign({ name: name }, rest), void 0), label: jsx(LabelText, { children: label }, void 0) }, void 0) }, void 0));
};
const LabelText = styled$3('span')(({ theme }) => ({
    fontSize: 14,
    lineHeight: '140%',
    letterSpacing: '0.15px',
    color: theme.palette.text.primary,
}));

function AppLink(_a) {
    var { children, to, inline, noDecoration = false } = _a, props = __rest(_a, ["children", "to", "inline", "noDecoration"]);
    const component = inline ? 'span' : 'div';
    // if (type === 'light') {
    //   return (
    //     <Box>
    //       <Link component={RouterLink} to={to} {...props}>
    //         {children}
    //       </Link>
    //     </Box>
    //   )
    // }
    return (jsx(Box$2, Object.assign({ component: component, fontWeight: 700 }, { children: jsx(Link, Object.assign({ component: Link$1, to: to }, props, { style: noDecoration ? { textDecoration: 'none', color: 'inherit' } : {} }, { children: children }), void 0) }), void 0));
}

const DividerSpaced = styled$3(Divider)({
    marginTop: '1em',
    marginBottom: '1em',
});

const initialState = {
    loaderOn: () => { },
    loaderOff: () => { },
    wrapPromise: () => __awaiter(void 0, void 0, void 0, function* () { }),
};
const LoadingIndicatorContext = createContext(initialState);
const LoadingIndicatorProvider = ({ children }) => {
    const [indicatorIsOn, setIndicatorIsOn] = useState(false);
    const counter = useRef(0);
    const loaderOn = () => setIndicatorIsOn(true);
    const loaderOff = () => setIndicatorIsOn(false);
    const wrapPromise = (activity) => {
        loaderOn();
        counter.current++;
        return activity.finally(() => {
            if (--counter.current === 0) {
                loaderOff();
            }
        });
    };
    return (jsxs(Fragment, { children: [indicatorIsOn && jsx(LoadingIndicatorComponent, {}, void 0),
            jsx(LoadingIndicatorContext.Provider, Object.assign({ value: { loaderOn, loaderOff, wrapPromise } }, { children: children }), void 0)] }, void 0));
};
// Loader hook
const useLoadingIndicator = () => {
    return useContext(LoadingIndicatorContext);
};
// Loader component
const useStyles$1 = makeStyles$1((theme) => createStyles({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));
function LoadingIndicatorComponent() {
    const styles = useStyles$1();
    return (jsx(Backdrop, Object.assign({ className: styles.backdrop, open: true }, { children: jsx(CircularProgress$2, { color: "inherit" }, void 0) }), void 0));
}

var styled = function styled(Component) {
  var componentCreator = styled$2(Component);
  return function (style, options) {
    return componentCreator(style, _extends({
      defaultTheme: defaultTheme$1
    }, options));
  };
};

var styled$1 = styled;

var styleFunction = css(compose(borders$1, display, flexbox$1, grid$1, positions, palette$1, shadows, sizing$1, spacing, typography$1));
/**
 * @ignore - do not document.
 */

var Box = styled$1('div')(styleFunction, {
  name: 'MuiBox'
});
var Box$1 = Box;

var SIZE = 44;
var styles$7 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },

    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = /*#__PURE__*/React$5.forwardRef(function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/React$5.createElement("div", _extends({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: _extends({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/React$5.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/React$5.createElement("circle", {
    className: clsx(classes.circle, disableShrink && classes.circleDisableShrink, {
      'determinate': classes.circleDeterminate,
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
process.env.NODE_ENV !== "production" ? CircularProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary']),

  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */
  disableShrink: chainPropTypes(PropTypes.bool, function (props) {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('Material-UI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }

    return null;
  }),

  /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The thickness of the circle.
   */
  thickness: PropTypes.number,

  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: chainPropTypes(PropTypes.oneOf(['determinate', 'indeterminate', 'static']), function (props) {
    var variant = props.variant;

    if (variant === 'static') {
      throw new Error('Material-UI: `variant="static"` was deprecated. Use `variant="determinate"` instead.');
    }

    return null;
  })
} : void 0;
var CircularProgress$1 = withStyles(styles$7, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress);

function useTheme() {
  var theme = useTheme$1() || defaultTheme$1;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__default.useDebugValue(theme);
  }

  return theme;
}

const generateClassName = createGenerateClassName({
    productionPrefix: 'cloader-',
});
const LoadingSpinner = (_a) => {
    var { height = 300, showReason = true, reason } = _a, props = __rest(_a, ["height", "showReason", "reason"]);
    const [displayReason, setDisplayReason] = useState(showReason);
    function toggleReason() {
        setDisplayReason(!showReason);
    }
    React__default.useEffect(() => {
        console.debug('loadingSpinnerReason', reason);
        if (!reason)
            console.trace('loading spinner with no reason');
    }, [reason]);
    return (jsx(StylesProvider, Object.assign({ generateClassName: generateClassName }, { children: jsxs(Box$1, Object.assign({ onClick: toggleReason, display: "flex", alignItems: "center", justifyContent: "center", minHeight: height }, { children: [jsx(CircularProgress$1, Object.assign({ disableShrink: true }, props), void 0),
                displayReason && jsxs(PreviewTitle, { children: ["Loading: ", reason] }, void 0)] }), void 0) }), void 0));
};

var PopupAlign;
(function (PopupAlign) {
    PopupAlign["TopLeft"] = "top-left";
    PopupAlign["TopMiddle"] = "top-middle";
    PopupAlign["TopRight"] = "top-right";
    PopupAlign["MiddleLeft"] = "middle-left";
    PopupAlign["Middle"] = "middle";
    PopupAlign["MiddleRight"] = "middle-right";
    PopupAlign["BottomLeft"] = "bottom-left";
    PopupAlign["BottomMiddle"] = "bottom-middle";
    PopupAlign["BottomRight"] = "bottom-right";
})(PopupAlign || (PopupAlign = {}));
var PopupSize;
(function (PopupSize) {
    PopupSize["Small"] = "small";
    PopupSize["Medium"] = "medium";
    PopupSize["Large"] = "large";
    PopupSize["XL"] = "xl";
})(PopupSize || (PopupSize = {}));
const positionValues = {
    [PopupAlign.TopLeft]: { top: '0', left: '0' },
    [PopupAlign.TopMiddle]: { top: '0', left: '50%' },
    [PopupAlign.TopRight]: { top: '0', right: '0' },
    [PopupAlign.MiddleLeft]: { top: '50%', left: '0' },
    [PopupAlign.Middle]: { top: '50%', left: '50%' },
    [PopupAlign.MiddleRight]: { top: '50%', right: '0' },
    [PopupAlign.BottomLeft]: { bottom: '0', left: '0' },
    [PopupAlign.BottomMiddle]: { bottom: '0', left: '50%' },
    [PopupAlign.BottomRight]: { bottom: '0', right: '0' },
};
const transformValues = {
    [PopupAlign.TopLeft]: 'translate(0, 0)',
    [PopupAlign.TopMiddle]: 'translate(-50%, 0)',
    [PopupAlign.TopRight]: 'translate(0, 0)',
    [PopupAlign.MiddleLeft]: 'translate(0, -50%)',
    [PopupAlign.Middle]: 'translate(-50%, -50%)',
    [PopupAlign.MiddleRight]: 'translate(0, -50%)',
    [PopupAlign.BottomLeft]: 'translate(0, 0)',
    [PopupAlign.BottomMiddle]: 'translate(-50%, 0)',
    [PopupAlign.BottomRight]: 'translate(0, 0)',
};
const sizeValues = {
    [PopupSize.Small]: { minWidth: '300px', padding: '20px' },
    [PopupSize.Medium]: { minWidth: '400px', padding: '30px' },
    [PopupSize.Large]: { minWidth: '500px', padding: '40px' },
    [PopupSize.XL]: { minWidth: '600px', padding: '50px' },
};
const Popup = ({ open, setOpen, children, size = PopupSize.Medium, align = PopupAlign.Middle, onClickAway, borderRadius, borderTopLeftRadius, borderTopRightRadius, borderBottomLeftRadius, borderBottomRightRadius, bgcolor, }) => {
    const handleClose = () => setOpen(false);
    const theme = useTheme$2();
    bgcolor = bgcolor !== null && bgcolor !== void 0 ? bgcolor : theme.palette.common.white;
    borderRadius = borderRadius !== null && borderRadius !== void 0 ? borderRadius : `${theme.shape.borderRadius * 2.5}px`;
    borderTopLeftRadius = borderTopLeftRadius !== null && borderTopLeftRadius !== void 0 ? borderTopLeftRadius : borderRadius;
    borderTopRightRadius = borderTopRightRadius !== null && borderTopRightRadius !== void 0 ? borderTopRightRadius : borderRadius;
    borderBottomLeftRadius = borderBottomLeftRadius !== null && borderBottomLeftRadius !== void 0 ? borderBottomLeftRadius : borderRadius;
    borderBottomRightRadius = borderBottomRightRadius !== null && borderBottomRightRadius !== void 0 ? borderBottomRightRadius : borderRadius;
    return (jsx(Modal, Object.assign({ open: open, onClose: handleClose }, { children: jsx(ClickAwayListener$1, Object.assign({ onClickAway: () => (onClickAway ? onClickAway() : handleClose()) }, { children: jsx(Box$2, Object.assign({ style: Object.assign(Object.assign(Object.assign(Object.assign({ position: 'absolute' }, positionValues[align]), { transform: transformValues[align], background: bgcolor }), sizeValues[size]), { borderTopLeftRadius,
                    borderTopRightRadius,
                    borderBottomLeftRadius,
                    borderBottomRightRadius }) }, { children: children }), void 0) }), void 0) }), void 0));
};
const usePopup = (props) => {
    const [popupOpen, setPopupOpen] = useState(false);
    const InternalPopup = useCallback(({ children }) => (jsx(Popup, Object.assign({ open: popupOpen, setOpen: setPopupOpen }, props, { children: children }), void 0)), [popupOpen, setPopupOpen]);
    return { Popup: InternalPopup, setPopupOpen };
};

function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar(event) {
  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */


function ClickAwayListener(props) {
  var children = props.children,
      _props$disableReactTr = props.disableReactTree,
      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
      _props$mouseEvent = props.mouseEvent,
      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
      onClickAway = props.onClickAway,
      _props$touchEvent = props.touchEvent,
      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
  var movedRef = React$5.useRef(false);
  var nodeRef = React$5.useRef(null);
  var activatedRef = React$5.useRef(false);
  var syntheticEventRef = React$5.useRef(false);
  React$5.useEffect(function () {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(function () {
      activatedRef.current = true;
    }, 0);
    return function () {
      activatedRef.current = false;
    };
  }, []); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = React$5.useCallback(function (instance) {
    // #StrictMode ready
    nodeRef.current = ReactDOM.findDOMNode(instance);
  }, []);
  var handleRef = useForkRef(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviours like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  var handleClickAway = useEventCallback(function (event) {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    var insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!activatedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
      var doc = ownerDocument(nodeRef.current);
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
    return function (event) {
      syntheticEventRef.current = true;
      var childrenPropsHandler = children.props[handlerName];

      if (childrenPropsHandler) {
        childrenPropsHandler(event);
      }
    };
  };

  var childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  React$5.useEffect(function () {
    if (touchEvent !== false) {
      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
      var doc = ownerDocument(nodeRef.current);

      var handleTouchMove = function handleTouchMove() {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return function () {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  React$5.useEffect(function () {
    if (mouseEvent !== false) {
      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      var doc = ownerDocument(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return function () {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/React$5.createElement(React$5.Fragment, null, /*#__PURE__*/React$5.cloneElement(children, childrenProps));
}

process.env.NODE_ENV !== "production" ? ClickAwayListener.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The wrapped element.
   */
  children: elementAcceptingRef$1.isRequired,

  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   */
  disableReactTree: PropTypes.bool,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: PropTypes.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: PropTypes.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: PropTypes.oneOf(['onTouchEnd', 'onTouchStart', false])
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  ClickAwayListener['propTypes' + ''] = exactProp(ClickAwayListener.propTypes);
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : PropTypes.instanceOf(Element)
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
var TransitionGroup$1 = TransitionGroup;

var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles$6 = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = /*#__PURE__*/React$5.forwardRef(function Grow(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Transition$1 : _props$TransitionComp,
      other = _objectWithoutProperties(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var timer = React$5.useRef();
  var autoTimeout = React$5.useRef();
  var theme = useTheme();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = React$5.useRef(null);
  var foreignRef = useForkRef(children.ref, ref);
  var handleRef = useForkRef(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = _slicedToArray(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    reflow(node); // So the animation always start from the start.

    var _getTransitionProps = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        delay = _getTransitionProps.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var _getTransitionProps2 = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        delay = _getTransitionProps2.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };

  React$5.useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/React$5.createElement(TransitionComponent, _extends({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/React$5.cloneElement(children, _extends({
      style: _extends({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles$6[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
process.env.NODE_ENV !== "production" ? Grow.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Grow.muiSupportAuto = true;
var Grow$1 = Grow;

var styles$5 = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return _extends({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = /*#__PURE__*/React$5.forwardRef(function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/React$5.createElement(Component, _extends({
    className: clsx(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Paper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: chainPropTypes(PropTypes.number, function (props) {
    var classes = props.classes,
        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning

    if (classes === undefined) {
      return null;
    }

    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
    }

    return null;
  }),

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['elevation', 'outlined'])
} : void 0;
var Paper$1 = withStyles(styles$5, {
  name: 'MuiPaper'
})(Paper);

var styles$4 = function styles(theme) {
  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = emphasize(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: _extends({}, theme.typography.body2, _defineProperty({
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      flexGrow: 1
    }, theme.breakpoints.up('sm'), {
      flexGrow: 'initial',
      minWidth: 288
    })),

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: -8
    }
  };
};
var SnackbarContent = /*#__PURE__*/React$5.forwardRef(function SnackbarContent(props, ref) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      _props$role = props.role,
      role = _props$role === void 0 ? 'alert' : _props$role,
      other = _objectWithoutProperties(props, ["action", "classes", "className", "message", "role"]);

  return /*#__PURE__*/React$5.createElement(Paper$1, _extends({
    role: role,
    square: true,
    elevation: 6,
    className: clsx(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/React$5.createElement("div", {
    className: classes.message
  }, message), action ? /*#__PURE__*/React$5.createElement("div", {
    className: classes.action
  }, action) : null);
});
process.env.NODE_ENV !== "production" ? SnackbarContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The message to display.
   */
  message: PropTypes.node,

  /**
   * The ARIA role attribute of the element.
   */
  role: PropTypes.string
} : void 0;
var SnackbarContent$1 = withStyles(styles$4, {
  name: 'MuiSnackbarContent'
})(SnackbarContent);

var styles$3 = function styles(theme) {
  var top1 = {
    top: 8
  };
  var bottom1 = {
    bottom: 8
  };
  var right = {
    justifyContent: 'flex-end'
  };
  var left = {
    justifyContent: 'flex-start'
  };
  var top3 = {
    top: 24
  };
  var bottom3 = {
    bottom: 24
  };
  var right3 = {
    right: 24
  };
  var left3 = {
    left: 24
  };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 8,
      right: 8,
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
    anchorOriginTopCenter: _extends({}, top1, _defineProperty({}, theme.breakpoints.up('sm'), _extends({}, top3, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
    anchorOriginBottomCenter: _extends({}, bottom1, _defineProperty({}, theme.breakpoints.up('sm'), _extends({}, bottom3, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
    anchorOriginTopRight: _extends({}, top1, right, _defineProperty({}, theme.breakpoints.up('sm'), _extends({
      left: 'auto'
    }, top3, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
    anchorOriginBottomRight: _extends({}, bottom1, right, _defineProperty({}, theme.breakpoints.up('sm'), _extends({
      left: 'auto'
    }, bottom3, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
    anchorOriginTopLeft: _extends({}, top1, left, _defineProperty({}, theme.breakpoints.up('sm'), _extends({
      right: 'auto'
    }, top3, left3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
    anchorOriginBottomLeft: _extends({}, bottom1, left, _defineProperty({}, theme.breakpoints.up('sm'), _extends({
      right: 'auto'
    }, bottom3, left3)))
  };
};
var Snackbar = /*#__PURE__*/React$5.forwardRef(function Snackbar(props, ref) {
  var action = props.action,
      _props$anchorOrigin = props.anchorOrigin;
  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'bottom',
    horizontal: 'center'
  } : _props$anchorOrigin;

  var vertical = _props$anchorOrigin.vertical,
      horizontal = _props$anchorOrigin.horizontal,
      _props$autoHideDurati = props.autoHideDuration,
      autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati,
      children = props.children,
      classes = props.classes,
      className = props.className,
      ClickAwayListenerProps = props.ClickAwayListenerProps,
      ContentProps = props.ContentProps,
      _props$disableWindowB = props.disableWindowBlurListener,
      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
      message = props.message,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      open = props.open,
      resumeHideDuration = props.resumeHideDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Grow$1 : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? {
    enter: duration.enteringScreen,
    exit: duration.leavingScreen
  } : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      other = _objectWithoutProperties(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var timerAutoHide = React$5.useRef();

  var _React$useState = React$5.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var handleClose = useEventCallback(function () {
    if (onClose) {
      onClose.apply(void 0, arguments);
    }
  });
  var setAutoHideTimer = useEventCallback(function (autoHideDurationParam) {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }

    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(function () {
      handleClose(null, 'timeout');
    }, autoHideDurationParam);
  });
  React$5.useEffect(function () {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }

    return function () {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
  // or when the user hide the window.

  var handlePause = function handlePause() {
    clearTimeout(timerAutoHide.current);
  }; // Restart the timer when the user is no longer interacting with the Snackbar
  // or when the window is shown back.


  var handleResume = React$5.useCallback(function () {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);

  var handleMouseEnter = function handleMouseEnter(event) {
    if (onMouseEnter) {
      onMouseEnter(event);
    }

    handlePause();
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    handleResume();
  };

  var handleClickAway = function handleClickAway(event) {
    if (onClose) {
      onClose(event, 'clickaway');
    }
  };

  var handleExited = function handleExited() {
    setExited(true);
  };

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  React$5.useEffect(function () {
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return function () {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }

    return undefined;
  }, [disableWindowBlurListener, handleResume, open]); // So we only render active snackbars.

  if (!open && exited) {
    return null;
  }

  return /*#__PURE__*/React$5.createElement(ClickAwayListener, _extends({
    onClickAway: handleClickAway
  }, ClickAwayListenerProps), /*#__PURE__*/React$5.createElement("div", _extends({
    className: clsx(classes.root, classes["anchorOrigin".concat(capitalize(vertical)).concat(capitalize(horizontal))], className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: ref
  }, other), /*#__PURE__*/React$5.createElement(TransitionComponent, _extends({
    appear: true,
    in: open,
    onEnter: createChainedFunction(handleEnter, onEnter),
    onEntered: onEntered,
    onEntering: onEntering,
    onExit: onExit,
    onExited: createChainedFunction(handleExited, onExited),
    onExiting: onExiting,
    timeout: transitionDuration,
    direction: vertical === 'top' ? 'down' : 'up'
  }, TransitionProps), children || /*#__PURE__*/React$5.createElement(SnackbarContent$1, _extends({
    message: message,
    action: action
  }, ContentProps)))));
});
process.env.NODE_ENV !== "production" ? Snackbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: PropTypes.node,

  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['center', 'left', 'right']).isRequired,
    vertical: PropTypes.oneOf(['bottom', 'top']).isRequired
  }),

  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: PropTypes.number,

  /**
   * Replace the `SnackbarContent` component.
   */
  children: PropTypes.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Props applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: PropTypes.object,

  /**
   * Props applied to the [`SnackbarContent`](/api/snackbar-content/) element.
   */
  ContentProps: PropTypes.object,

  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   */
  disableWindowBlurListener: PropTypes.bool,

  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key prop to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: PropTypes.any,

  /**
   * The message to display.
   */
  message: PropTypes.node,

  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the transition is entering.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the transition has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the transition is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired before the transition is exiting.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the transition has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the transition is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  onMouseEnter: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * If `true`, `Snackbar` is open.
   */
  open: PropTypes.bool,

  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: PropTypes.number,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
var Snackbar$1 = withStyles(styles$3, {
  flip: false,
  name: 'MuiSnackbar'
})(Snackbar);

var useEnhancedEffect = typeof window === 'undefined' ? React$5.useEffect : React$5.useLayoutEffect;
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = React$5.useState(false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = clsx(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = useEventCallback(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return /*#__PURE__*/React$5.createElement("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /*#__PURE__*/React$5.createElement("span", {
    className: childClassName
  }));
}

process.env.NODE_ENV !== "production" ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,

  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,

  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;

var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles$2 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = /*#__PURE__*/React$5.forwardRef(function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties(props, ["center", "classes", "className"]);

  var _React$useState = React$5.useState([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = React$5.useRef(0);
  var rippleCallback = React$5.useRef(null);
  React$5.useEffect(function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = React$5.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = React$5.useRef(null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = React$5.useRef(null);
  var container = React$5.useRef(null);
  React$5.useEffect(function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = React$5.useCallback(function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(_toConsumableArray(oldRipples), [/*#__PURE__*/React$5.createElement(Ripple, {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = React$5.useCallback(function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = React$5.useCallback(function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = React$5.useCallback(function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  React$5.useImperativeHandle(ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/React$5.createElement("span", _extends({
    className: clsx(classes.root, className),
    ref: container
  }, other), /*#__PURE__*/React$5.createElement(TransitionGroup$1, {
    component: null,
    exit: true
  }, ripples));
});
process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
var TouchRipple$1 = withStyles(styles$2, {
  flip: false,
  name: 'MuiTouchRipple'
})( /*#__PURE__*/React$5.memo(TouchRipple));

var styles$1 = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = /*#__PURE__*/React$5.forwardRef(function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = _objectWithoutProperties(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = React$5.useRef(null);

  function getButtonNode() {
    // #StrictMode ready
    return ReactDOM.findDOMNode(buttonRef.current);
  }

  var rippleRef = React$5.useRef(null);

  var _React$useState = React$5.useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  React$5.useImperativeHandle(action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  React$5.useEffect(function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return useEventCallback(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = useEventCallback(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = React$5.useRef(false);
  var handleKeyDown = useEventCallback(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = useEventCallback(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = useForkRef(buttonRefProp, ref);
  var handleOwnRef = useForkRef(focusVisibleRef, buttonRef);
  var handleRef = useForkRef(handleUserRef, handleOwnRef);

  var _React$useState2 = React$5.useState(false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  React$5.useEffect(function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$5.useEffect(function () {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }

  return /*#__PURE__*/React$5.createElement(ComponentProp, _extends({
    className: clsx(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  /*#__PURE__*/

  /* TouchRipple is only needed client-side, x2 boost on the server. */
  React$5.createElement(TouchRipple$1, _extends({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
process.env.NODE_ENV !== "production" ? ButtonBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType$1,

  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: refType$1,

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: PropTypes.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   */
  focusRipple: PropTypes.bool,

  /**
   * This prop can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * @ignore
   */
  href: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,

  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,

  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,

  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,

  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string])
} : void 0;
var ButtonBase$1 = withStyles(styles$1, {
  name: 'MuiButtonBase'
})(ButtonBase);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: fade(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/React$5.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/React$5.createElement(ButtonBase$1, _extends({
    className: clsx(classes.root, className, color !== 'default' && classes["color".concat(capitalize(color))], disabled && classes.disabled, size === "small" && classes["size".concat(capitalize(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/React$5.createElement("span", {
    className: classes.label
  }, children));
});
process.env.NODE_ENV !== "production" ? IconButton.propTypes = {
  /**
   * The icon element.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var found = React$5.Children.toArray(props.children).some(function (child) {
      return /*#__PURE__*/React$5.isValidElement(child) && child.props.onClick;
    });

    if (found) {
      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['start', 'end', false]),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium'])
} : void 0;
var IconButton$1 = withStyles(styles, {
  name: 'MuiIconButton'
})(IconButton);

var Close = {};

var _interopRequireDefault = interopRequireDefault.exports;

var _interopRequireWildcard = interopRequireWildcard.exports;

Object.defineProperty(Close, "__esModule", {
  value: true
});
var default_1 = Close.default = void 0;

var React = _interopRequireWildcard(React__default);

var _createSvgIcon = _interopRequireDefault(createSvgIcon$1);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

default_1 = Close.default = _default;

const uninitialisedFn = () => {
    throw new Error('uninitialised');
};
const defaultValue = {
    open: false,
    setOpen: uninitialisedFn,
    text: 'uninitialised value',
    setTextAndOpen: uninitialisedFn,
    severity: 'info',
};
const SnackbarStyledContext = React__default.createContext(defaultValue);
const SnackbarStyledProvider = ({ children }) => {
    const [text, setText] = useState('uninitialised value');
    const [severity, setSeverity] = useState('info');
    const [open, setOpen] = useState(false);
    const setTextAndOpen = (text, severity = 'info') => {
        setOpen(false);
        setText(text);
        setSeverity(severity);
        setOpen(true);
    };
    return (jsx(SnackbarStyledContext.Provider, Object.assign({ value: { open, setOpen, text, setTextAndOpen, severity } }, { children: children }), void 0));
};
const useSnackbar = () => useContext(SnackbarStyledContext);

function SnackbarStyled() {
    const { open, setOpen, text, severity } = useSnackbar();
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen && setOpen(false);
    };
    return (jsx("div", { children: jsx(Snackbar$1, Object.assign({ anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, open: open, autoHideDuration: 6000, onClose: handleClose, 
            // message={text}
            action: jsx(IconButton$1, Object.assign({ size: "small", "aria-label": "close", color: "inherit", onClick: handleClose }, { children: jsx(default_1, { fontSize: "small" }, void 0) }), void 0) }, { children: jsx(Alert, Object.assign({ severity: severity }, { children: text }), void 0) }), void 0) }, void 0));
}

const Spacing = ({ value = 20 }) => {
    return jsx(Box$2, { height: value }, void 0);
};

var img$O = "data:image/png;base64,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";

var img$N = "data:image/png;base64,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";

var img$M = "data:image/png;base64,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";

var img$L = "data:image/png;base64,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";

var img$K = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAA3NSURBVHgB5Zx5bBz3dcffzG/und3Z5e5yl+RSpKhVGFMOJZm2ZCtOykSOU9dwDbiVGxhqKzgFeiFujRZo/2hRBkVb1AWaFAXctKjTwk1c1AqawIqd2LlkhIkl55Iok7KUFc17ufc1O/eR35ChQ4nUQe5QlpjPP7uY2dnd+c77vfd+73cQcNMYIQFO00ND3UhVKVJRFMo7KgiIXP0pRbEdkmRcmrYcUaTsWm3WzmREC+C4DTcBArYMF3/3rzGDg3so111gbJtv6bcQUl3bDpuG8Y6Zybxi4L/uwhawBYIMU0ND72MMQ2ZbFeFaUJShj41pmt+W4+MfHqb6+/t4hAgabiK27ZoXLkyqACct8AEfBDmC+vuDws0WYi2sMTHRrmBf5UALINg0LpFKTfCpVEgkSaKF7/ELG8XjdY5l01CvT2zaWjZpISPkvn1TIcO4PELcKjCM7Zw501vfjLVsWJCBgREGoYuBrXSYfoAQ4zYaqjo19d/ahq7byIdTqad5li0EXJe+pcXwcF2boGmS3mgTumFBPDFCoToPtxksy25IlBsS5HYVY4WNiHJdQW53MVa4UVGu6QvS6U+xDKMEYFvRLU9MjBhXO3uNsDlC8nxJgG0GQrnAckdzfa56wsszbvXQuhls2yD6+haCy53PtawriOc3btWkyw84zkap1OPceufWuekRcjs40esRCoX4I0eOrAkqawQZGMhvO79xNcbGgmvu9QpBRnAVS2fglwSvhz48PEytPnaZIP39M9u+qVxJNtt32T2v8rQvooGBVyXwEVHkiHAXj+YuVDbdHf/TPzrcsW8nfQA/Or5pUgsTs40Ln//8aEFV7ZbqHqtpb79UP3lyucD0riCDg78dsCyGBZ945s/23R+TAo+aptFzZlp5+t+eH5+HTXD8H+/7QnNq7CMIUUCLEsUKvE20dZ2aqfJ/99Rfvfwj8IFKBWnZ7H8o3vsVL0tEo/eI4COH94dSvFX727dPnXpfulsQf/yW+lrTcjdcGEZa/fTcbP71+Yr1Uj6ff1PJZVNkZfZAT2/s1+9/cOjcy69emIIWEUUa5fM/0AE+vSxIOv0Qi1DQN2f6e4/EupLBxkPINffjBIgTkH3HndFS6YeL0lnD2FjreWtGb5xZoKd+NE1MnpqkzpR16XhClA1OKx2KBKgDNTr2xUuXCi3VU71SgSR9zimXM/aSIMnkg7xXggMfOPrortjHBpkXkp1dvylIYT7WHgWOoRFt1T8cYBujZ2eZTTWdFRZrpjnvhn8wEK7vF2nnYPquwdmXXr14FloEd/7cXG7MXIoyuANHgQ/s3ZugP7ZP/MM3x6f3vZ2ZJkhNBtI2geZYEGMJblecfQx8IJORTR1J39LLOYs3C4+CD7iuuNRCSC+6+JWmH3u471cDPPpkdxsLYfz1iAsAEkT8YzggOBYEGPdQX5L2JbS74GhAEoRl2740da+P42XpZDr9X75Yh0ejkn2SD0nBvp290N6RBNPUwaiXwagVIdR/AKRgoOdDqeJ+aJG9e/voKN142HUsJDvCd8En0unTNNlsdvs2hBAfuPfLBVeCiaIF2ZIM5VwOGuUiBHffBeriJNjVrBATzYehBVIpmvrkXTNPIrn4gCl1Fb5+uvIs+ISnBRUKWcivAbwvfeXUiYGd9CFFrt0zg9zevp098P6BPUA0suDoChZmP3Hn3d1H/yR2buwzL5ZfJEl6TRiORh10oFsQUuFmJCi6Uc7VeK3ZJBzHccMBalecs55gazBEdO5WCm5k5MSJczL4RCRCkcTQ0BFJVUO+WYnjmMTvPnFv784e9NU9gx9IhmgLnHoB9xtIYKQkqHIDJl95zphdKP7reCHx7xUuqop2g+oMWW2dEf39IWh+mCWsO8E106Rttbm2hWwXSLOp4ehoE8H2LqBjXcUyl/qH5/6/8sXMomyCT3jjOcS+fcfCftc+olEBPfNPT3wumYg9howqEJYGNMsBH05A/vQJKI1/D+SFKVfR1EWXJBuIIFhEODGGxSkLAQRORwEsAyiGB8c0gKA5UFQdULANKopVK0DyDz57wnwNfMYThNqKQlCppNiGRUwYtvMYjxggCAKoUDtYah2M8jxIqd0AmkzwttVhNqodtBgBW20A15YAR5GBEoLgGlgAXliKTri14GwyAg4t4sw1TztNBQ9u+z+U7GnhW4S5kmpDvRBpC9hCKIQoCgGJn7qePQ9cOIZdFgGBRA9gxwA6uwhstAPU/NzSMaNeAloIeYkBODiHISgGTE0Bmg+BjsXiXEsQrPwjorhrVJY13+eIbJkgtUJjVosHFCsQCNI0AtcywZSrODcRwFGbwEcTYOv4QYODLSMJNr5pBotFYvEI3JEjSARms4ENgQUKvydxTmNbFnidPMqq35EUdSojg2/+Y4UtE6ShaTXDMqq2bQVdl8GWb+DkxwYL52gkNkwaNw+yWcfNQgRaigGHmwYTiWNL4gA7T0AMtgyCWhIHDyaDhQVzsWWxkgRMrc7rtIabum+d83ehPEeyFX6kUKzLmtomq6qKi7ockK4FJG4KhqYBIl3sJ6L4Zjncu3QBiWGgsZ8AXsIWwmIxcP0XWwXh0l4KCYhl8YsDjlsGvVzAjlZrCq5og88GsuRUYYt45Ss/qdy9v3NclpU7RDEIiCLBZYNgUzK4WAiTbwNSjC/5ERsLQNISPk5i4ZxlQRCNb5wGq1FailK4QwRCew92vgrUZRmn603vFsBPZNl0SMMQfJmKtPbLNVfX7B8rimI1ZRl0nEw4bAg0FIQaIYJs0aC4HKgoAAbJg8lFQKew46QjILs8Pk/hcxLIFI5AUgpQGEcp3Oy8MhlOS6JxCTjwGYRYl6pULCcSgS2hVNFeZxh3odnkdyCKwFGDAB0/1XwpDxGHBBpHEBJbBUVRS8mybdmgGwZ4zczQl18JkgA70Q4RIQ5MlwBePYXJ5aQolRO8YUnwkXqdslEy2U76WRxazdmfvFO+656eAE2RBwWORaZpgtzAmerkJGiajvsOTahWq1AsFGFhYRFmZqbd6ZlZfW5uQZmbX7BzuRzdqNXBi60kLeAmxWARsYOVqwwXFF4bnSDnwEd4PqWhcvmo683Ngi3AwiVDXIw6t7s/figUFLt13P6npqbg7NlzUC6XjVKpUs0u5nO5fPH0wnzu5WJZ/s/FXP1f5ufLz2UXc5libvGj1VodmdhqvBKCg6sVKBjFscUg3XouyLdFvn1xGmdwPjExMadS3jwshjnmbNXQ5ejoT+Xf+sS947hpHGoqCly8mIEafurFkvsl0wr9vaIQGvarSqVCG7Is/zzRIuDwr/QEGo151TAN5u3zF4EXgt9RVO2Dqqox8fgARMXIQx8NTnz2/ELi9zOZXMvhxpuC5c15XRIhm7V9T3BWw4uhLO6i4Op2FfsRB3p3dEN3KjV5/ryTnZ62K7Oztn5l1nnmzezFcDgylUwm8DBB3MkV3E/li+QD+ULpG9jKjCbXQXXsvf/RP/6dPb5U4XC/cUmDpbAbDOICBnT6n+X8HJalBVyRwj5Dnenu6a3jJO3O+cUyziOqV72mpLJ6omvHdwIcuVc3rOJ3v9coZjIXsvjUJx55ZHd3LK691NGV3sGasw/iY/8HLdO+NGdkyUIyma8ZXlICWwTL0J2GroOmm9+UwrFXI5Gw99SD17vOs46OjqTbFo1+f3WzOHHip7O8KL3u5XKmS/vyvycm/uYXFoLBFWfGiERsX51rtKcdPfEbH0xwHHWwuCg7jQb1hVCED4gB6ikSCeGrXXf33Xv4w4d370inpceURs3IFclnVs61t4fJoaGdgUg0usPF8ceE1kuI3rz5lcUE72aq/f2dRj4/65sgx449EHng4x/4a4ZBH8JJap+iqD/csaujWwqgP6dJFhd9NHW967wbfvzxO/4i1Z18nGXIhKHpX33++a9fXDn/1NMf/0jfzva/TMTje8ulvP3OTPUktMjyIoJl3hXk5MkRq7//SdOvOev5uoxdRTORn18M4+hyNlt0nhIY1M6TwlsN03y9UFGPr3tdvupMzlSP07jca9smcf587n9XO9zpmYUFKYgWGQoZuXx58vgLoy3lIt7igdUrKi4rpg4Pj1DYSkLgEwcP7gwwjBWs1VRlbKxY946FcZGYMQKOd+PXutYrRYZCQViv5pFKRahdu8LspUtVnMRVWup6rB7o9lhTXcZWEnzvVzbcLLwVFM9elv6vScYGBxsK/JKwvJzkctDaD024LDuMcwd9W1uJJNXVubln1ySk6w4/1OunbEkaoJFXxNiGaBqyz537n3V7yle7YTeT2S1vZbL2XuGt+pyc7Gxc7fy1ZjLjDl/vtvMnvb2gXWth0TVH7AqFk3Y6PQy6vj38iec3RkdfuOaCousOYc7NnbK2gyieGG+8cVy93uduaEz3dhflRsXwuOFB7ttVlI2I4bGhsPrGG59RDWNv83aIPl402bOnW96IGB6bXqbqLbHwVhXALYg3tJLJROWbskx1Nffd9zSP66O31HRwSQrhJvLP2mY3S/Bh6tAIubyC4r1dNLC8B4DXD2ttcwTfVkx5pYNsduY92Qyho2OH6tVzwAd8X0LmCVMuX2L9nDd/JZ7DjEYZIxjsNPwSYoUt3VBlYODT2FryjLebzJU7yWwUT4RQKGYqyrh1m22osj7ecq7x8T2I5xcoWbaQbeuEZdHkelvueK+CIFg8bzneljtHjx40R0ZGbkqo/xkPQWnX1nPoRQAAAABJRU5ErkJggg==";

var img$J = "data:image/png;base64,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";

var img$I = "data:image/png;base64,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";

var img$H = "data:image/png;base64,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";

var img$G = "data:image/png;base64,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";

var img$F = "data:image/png;base64,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";

var img$E = "data:image/png;base64,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";

var img$D = "data:image/png;base64,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";

var img$C = "data:image/png;base64,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";

var img$B = "data:image/png;base64,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";

var img$A = "data:image/png;base64,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";

var img$z = "data:image/png;base64,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";

var img$y = "data:image/png;base64,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";

var img$x = "data:image/png;base64,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";

var img$w = "data:image/png;base64,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";

var img$v = "data:image/png;base64,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";

const iconSet$1 = {
    icons: {
        anywhereIsOk: img$O,
        casualDrinking: img$L,
        cagedAnimalsOnly: img$M,
        petsAny: img$A,
        catsOnly: img$K,
        dogsOnly: img$I,
        neatFreak: img$G,
        clean: img$J,
        messy: img$H,
        average: img$N,
        peopleCanDoWhatTheyWant: img$B,
        vapingAnywhereIsOkay: img$z,
        noDrinking: img$F,
        noSmoking: img$E,
        noVaping: img$D,
        outdoorsOnly: img$C,
        noise1: img$y,
        noise2: img$x,
        noise3: img$w,
    },
    defaultIcon: img$v,
};

var img$u = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.15547 17.7944H5.60401L10.534 21.5111C11.3043 22.0888 12.3829 21.5496 12.3829 20.5867V3.4088C12.3829 2.46517 11.2851 1.90669 10.534 2.48442L5.60401 6.20117H1.15547C0.51996 6.20117 0 6.72113 0 7.35664V16.6583C0 17.2744 0.51996 17.7944 1.15547 17.7944Z' fill='%231A0154'/%3e%3cline x1='15.75' y1='7.5' x2='15.75' y2='16.5' stroke='%231A0154' stroke-width='1.5' stroke-linecap='round'/%3e%3cline x1='20.2324' y1='3.74927' x2='20.2324' y2='20.2493' stroke='%231A0154' stroke-width='1.5' stroke-linecap='round'/%3e%3c/svg%3e";

var img$t = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_12192_169596)'%3e%3cpath d='M16.0511 12.7198C14.9712 11.035 13.1319 10.0291 11.1309 10.0291C9.12991 10.0291 7.29062 11.035 6.21084 12.7198L3.60855 16.7794C3.17679 17.4529 2.97757 18.2311 3.03232 19.0292C3.08706 19.8276 3.39084 20.571 3.91067 21.1796C4.43088 21.7877 5.11825 22.2034 5.89847 22.3817C6.67868 22.5601 7.47848 22.4839 8.21127 22.1618L8.26034 22.14C10.1042 21.3457 12.2112 21.353 14.0503 22.1618C14.5247 22.3704 15.0274 22.4758 15.5346 22.4758C15.8103 22.4758 16.0877 22.4445 16.3626 22.3819C17.1428 22.2037 17.8302 21.7881 18.3506 21.1798C18.8706 20.5717 19.1745 19.8281 19.2295 19.0296C19.2844 18.2311 19.0852 17.4531 18.6534 16.7792L16.0511 12.7198Z' fill='%231A0154'/%3e%3cpath d='M4.30758 12.7144C5.08175 12.417 5.66988 11.7931 5.96358 10.9576C6.24318 10.1626 6.2203 9.26501 5.89895 8.43004C5.57741 7.59563 4.99257 6.91448 4.25209 6.51183C3.47426 6.08904 2.61971 6.02019 1.84682 6.3181C0.29189 6.91594 -0.421672 8.83745 0.256367 10.6024C0.797993 12.0072 2.06124 12.894 3.3384 12.894C3.66451 12.894 3.99154 12.8361 4.30758 12.7144Z' fill='%231A0154'/%3e%3cpath d='M9.35504 9.53375C11.2989 9.53375 12.8804 7.73199 12.8804 5.51733C12.8804 3.30212 11.2989 1.5 9.35504 1.5C7.41138 1.5 5.83008 3.30212 5.83008 5.51733C5.83008 7.73199 7.41138 9.53375 9.35504 9.53375Z' fill='%231A0154'/%3e%3cpath d='M15.4477 10.5204H15.4479C15.7469 10.6196 16.052 10.6671 16.3558 10.6671C17.7734 10.6671 19.1549 9.63527 19.682 8.04958C19.9856 7.1368 19.9657 6.17165 19.6258 5.33211C19.2702 4.45321 18.6112 3.81527 17.7701 3.53566C16.9287 3.25606 16.0188 3.3727 15.2079 3.86379C14.4331 4.3329 13.8395 5.09407 13.5363 6.00686C12.8963 7.93239 13.7538 9.95717 15.4477 10.5204V10.5204Z' fill='%231A0154'/%3e%3cpath d='M22.8698 10.0518L22.8693 10.0512C21.5288 9.06101 19.5239 9.49021 18.3999 11.0085C17.2769 12.5276 17.4525 14.5697 18.791 15.5607C19.2791 15.9223 19.8559 16.0952 20.4462 16.0952C21.4751 16.0952 22.5455 15.57 23.2611 14.6043C24.3839 13.0853 24.2085 11.0431 22.8698 10.0518V10.0518Z' fill='%231A0154'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_12192_169596'%3e%3crect width='24' height='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img$s = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_12192_169473)'%3e%3cpath d='M7.07821 15.332H8.4845C8.4845 13.7808 9.7459 12.5194 11.2971 12.5194V11.1131C9.7459 11.1131 8.4845 9.85172 8.4845 8.30054H7.07821C7.07821 9.85172 5.81681 11.1131 4.26562 11.1131V12.5194C5.81681 12.5194 7.07821 13.7808 7.07821 15.332Z' fill='%231A0154'/%3e%3cpath d='M2.85946 23.7685H4.26575C4.26575 22.2173 5.52715 20.9559 7.07833 20.9559V19.5496C5.52715 19.5496 4.26575 18.2882 4.26575 16.7371H2.85946C2.85946 18.2882 1.55119 19.5496 0 19.5496V20.9559C1.55119 20.9559 2.85946 22.2173 2.85946 23.7685Z' fill='%231A0154'/%3e%3cpath d='M22.8266 16.1211C23.2275 15.0211 22.6573 13.8148 21.5659 13.417L20.7927 13.1354C20.7996 12.5108 20.5166 11.9026 20.0223 11.4942L24.001 0.714835L22.6799 0.231445L18.7003 11.013C18.0664 11.0083 17.4569 11.2858 17.0538 11.7752L16.2799 11.4936C15.7519 11.3007 15.1785 11.3254 14.6669 11.5637C14.1567 11.8019 13.7694 12.2249 13.5765 12.7543L13.3359 13.4151L22.586 16.7818L22.8266 16.1211Z' fill='%231A0154'/%3e%3cpath d='M8.60118 17.4107L7.44141 17.3049L7.88772 18.3809C8.13011 18.9639 8.435 19.5201 8.79412 20.0337C9.68336 21.3075 11.1109 22.1329 12.7033 22.3217V23.1567L13.184 23.3167C13.8446 23.5378 14.5024 23.6951 15.1746 23.645C17.2587 23.645 19.2308 22.6177 20.4517 20.8969C21.0722 20.0229 21.5886 19.0726 22.0411 18.0801L12.8514 14.7354C12.1997 16.4812 10.4562 17.5745 8.60118 17.4107V17.4107Z' fill='%231A0154'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_12192_169473'%3e%3crect width='24' height='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img$r = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_12192_169592)'%3e%3cpath d='M17.7949 6.94229C17.7949 6.94229 15.4605 2.36868 14.4374 7.14906C12.9876 7.8868 10.6628 6.75583 7.88639 6.95294C6.92989 7.02109 0.00233231 6.86549 1.55297e-06 13.0087C-0.0023292 16.9342 2.61944 18.9508 4.2988 19.0229C4.68648 19.0387 6.19226 19.0229 6.28938 19.0177C6.80503 18.994 7.36363 18.9697 7.37018 18.6987C7.3835 18.1297 5.18349 17.8966 5.01101 17.7735C4.83965 17.6503 4.83965 16.8964 5.84653 17.1667C7.59082 17.6583 10.5805 17.3392 11.2683 17.1428C11.9561 16.9453 12.4072 17.9613 12.8001 18.5023C13.1932 19.043 13.8073 19.0178 13.8073 19.0178C13.8073 19.0178 15.896 19.0178 16.4124 19.0178C16.9279 19.0178 16.7562 18.4396 15.6259 18.1942C14.4956 17.9485 15.1238 17.3769 15.6259 16.8809C16.0883 16.4241 17.2608 15.208 18.1316 15.0623C23.9057 14.0797 23.8269 10.5167 23.7529 9.97649C25.3123 8.50634 19.0232 7.01698 17.7949 6.94229Z' fill='%231A0154'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_12192_169592'%3e%3crect width='24' height='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img$q = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_12192_169510)'%3e%3cpath d='M12.7031 0.703125C12.7031 0.314812 12.3883 0 12 0C11.6117 0 11.2969 0.314812 11.2969 0.703125V2.57812C11.2969 2.96644 11.6117 3.28125 12 3.28125C12.3883 3.28125 12.7031 2.96644 12.7031 2.57812V0.703125Z' fill='%231A0154'/%3e%3cpath d='M14.461 3.18776C14.7973 3.38191 15.2273 3.26669 15.4215 2.93041L16.359 1.30662C16.5531 0.970335 16.4379 0.540303 16.1016 0.346147C15.7654 0.151991 15.3353 0.26721 15.1412 0.603491L14.2037 2.22729C14.0095 2.56357 14.1248 2.9936 14.461 3.18776Z' fill='%231A0154'/%3e%3cpath d='M8.5787 2.93041C8.77285 3.26669 9.20289 3.38191 9.53917 3.18776C9.87545 2.9936 9.99067 2.56357 9.79651 2.22729L8.85901 0.603491C8.66485 0.26721 8.23482 0.151991 7.89854 0.346147C7.56225 0.540303 7.44703 0.970335 7.64119 1.30662L8.5787 2.93041Z' fill='%231A0154'/%3e%3cpath d='M10.8052 5.36056L4.41084 3.88432C4.07972 3.80786 3.74133 3.97919 3.60689 4.29124L2.21484 7.52281C2.67895 7.89448 3.21998 8.15764 3.80859 8.29353C3.81141 8.29419 3.81422 8.29489 3.81712 8.2955C3.819 8.29592 3.82083 8.29634 3.8227 8.29681C4.63706 8.49172 5.47898 8.42806 6.25542 8.11241C6.258 8.11137 6.26062 8.1103 6.2632 8.10931C7.29497 7.69044 8.41397 7.60053 9.49959 7.8493C9.50287 7.85005 9.5063 7.85084 9.50958 7.85159C10.1286 7.99452 10.7088 8.24141 11.2316 8.58055L11.3494 6.07873C11.3653 5.73931 11.1362 5.43701 10.8052 5.36056V5.36056Z' fill='%231A0154'/%3e%3cpath d='M9.18634 9.22124C8.38182 9.03688 7.55279 9.10396 6.78868 9.41516C6.78587 9.41628 6.78301 9.41746 6.78015 9.41858C5.74548 9.83797 4.62596 9.92666 3.53912 9.67574C3.5259 9.67269 3.51268 9.6696 3.49951 9.66641C3.49735 9.66594 3.49501 9.66538 3.4929 9.66486C2.8232 9.51027 2.1991 9.23389 1.64401 8.85083L1.50081 9.18322C0.911821 10.5505 0.959633 12.0965 1.63196 13.4248C2.19723 14.5416 3.14799 15.3936 4.29854 15.8357L3.17251 20.7129L0.53818 21.3485C0.221212 21.425 -0.00158525 21.7094 8.49563e-06 22.0355C0.00160225 22.3615 0.227212 22.6438 0.54493 22.7171L6.02574 23.9825C6.34346 24.0558 6.66995 23.9011 6.81432 23.6087C6.95874 23.3163 6.88313 22.963 6.63174 22.7553L4.54266 21.0292L5.66865 16.152C6.89659 16.259 8.12457 15.9101 9.12221 15.1541C10.3088 14.255 11.0295 12.8864 11.0995 11.3993L11.1502 10.3224C10.6157 9.77478 9.94304 9.39589 9.19365 9.22288C9.19126 9.22236 9.18877 9.2218 9.18634 9.22124V9.22124Z' fill='%231A0154'/%3e%3cpath d='M23.4616 21.3485L20.8273 20.7129L19.7013 15.8357C20.8519 15.3936 21.8026 14.5417 22.3679 13.4249C23.0402 12.0966 23.088 10.5505 22.499 9.18322L22.3558 8.85083C21.8007 9.23385 21.1767 9.51027 20.507 9.66486C20.5048 9.66538 20.5025 9.6659 20.5003 9.66641C20.4872 9.66955 20.474 9.67269 20.4607 9.67574C19.3739 9.92666 18.2544 9.83797 17.2197 9.41858C17.2169 9.41746 17.214 9.41628 17.2112 9.41516C16.4471 9.10396 15.618 9.03688 14.8135 9.22124C14.811 9.2218 14.8086 9.22236 14.8062 9.22293C14.0568 9.39594 13.3841 9.77479 12.8496 10.3224L12.9003 11.3993C12.9703 12.8865 13.691 14.2551 14.8776 15.1542C15.8752 15.9101 17.1033 16.2591 18.3312 16.1521L19.4571 21.0293L17.3681 22.7554C17.1167 22.9631 17.0411 23.3164 17.1855 23.6088C17.3299 23.9011 17.6564 24.0559 17.9741 23.9825L23.4549 22.7172C23.7726 22.6438 23.9982 22.3617 23.9998 22.0355C24.0014 21.7094 23.7786 21.425 23.4616 21.3485V21.3485Z' fill='%231A0154'/%3e%3cpath d='M14.5009 7.85063C15.5865 7.60187 16.7055 7.69177 17.7373 8.11065C17.7399 8.11168 17.7425 8.11271 17.7451 8.11374C18.5215 8.4294 19.3634 8.49305 20.1778 8.29815C20.1797 8.29768 20.1815 8.29726 20.1834 8.29684C20.1863 8.29623 20.1891 8.29552 20.1919 8.29487C20.7805 8.15898 21.3215 7.89582 21.7857 7.52415L20.3936 4.29259C20.2592 3.98049 19.9208 3.80921 19.5897 3.88566L13.1953 5.3619C12.8643 5.43835 12.6352 5.74065 12.6512 6.08007L12.769 8.58188C13.2917 8.24274 13.8719 7.99585 14.491 7.85293C14.4942 7.85218 14.4976 7.85138 14.5009 7.85063Z' fill='%231A0154'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_12192_169510'%3e%3crect width='24' height='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img$p = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M22.9303 12.8083C22.7131 10.4022 21.6731 8.1445 19.9854 6.41585C19.7927 6.23073 19.5358 6.12734 19.2686 6.12734C19.0014 6.12734 18.7446 6.23073 18.5519 6.41585C18.3696 6.59309 18.2612 6.83282 18.2485 7.08678C18.2359 7.34073 18.3199 7.59004 18.4838 7.7845C18.9061 8.28709 19.2777 8.83028 19.593 9.40612C20.3516 10.7561 20.6659 12.3106 20.4913 13.8493C20.3166 15.3879 19.6619 16.8325 18.62 17.978C18.176 18.4538 17.6762 18.8741 17.1313 19.2299V15.8926C17.1216 12.2472 13.807 10.7034 13.6708 10.6515C11.4394 9.61693 10.3432 7.05153 10.2265 6.75963C9.68485 3.64612 7.84268 2.65045 7.17457 2.3845C6.93133 1.62234 6.30539 0.743419 4.74863 0.649365C4.68757 0.646186 4.62685 0.660332 4.57349 0.690172C4.52012 0.720011 4.47627 0.764329 4.44701 0.818013C4.41699 0.871743 4.40288 0.932904 4.40633 0.994354C4.40977 1.0558 4.43063 1.115 4.46647 1.16504C4.65911 1.4669 4.75839 1.8189 4.75187 2.17693C4.12917 2.33585 2.60809 2.8872 2.41998 4.51207C2.41998 4.53153 2.3843 4.98882 1.66106 5.42342C1.53275 5.4803 1.41722 5.56246 1.32137 5.66499C1.22553 5.76752 1.15133 5.88832 1.10322 6.02018C0.957278 6.41909 1.05133 6.90558 1.4016 7.48288C1.44376 7.54126 2.37457 8.82558 3.96376 8.6245C3.95725 8.96665 3.88311 9.30412 3.74563 9.6175C3.60815 9.93087 3.41003 10.214 3.16268 10.4504C3.13746 10.4773 3.11666 10.5079 3.10106 10.5413C2.80127 11.3551 2.6913 12.2266 2.77955 13.0894C2.86779 13.9521 3.15192 14.7834 3.61025 15.5196C3.62634 15.5479 3.64719 15.5731 3.67187 15.5942C3.69133 15.6104 5.40376 17.125 4.9043 18.6688L4.31403 20.3845C4.29595 20.4394 4.26634 20.4898 4.22718 20.5323C4.18803 20.5748 4.14023 20.6085 4.08701 20.631L3.19836 21.0072C2.94893 21.1151 2.74421 21.3055 2.61859 21.5465C2.49297 21.7875 2.45409 22.0644 2.50848 22.3306C2.56288 22.5969 2.70723 22.8364 2.91731 23.0088C3.12738 23.1812 3.39038 23.2761 3.66214 23.2775H5.34214C5.56725 23.2766 5.78684 23.2077 5.97207 23.0798C6.15729 22.9519 6.29949 22.7709 6.37998 22.5607L7.56701 19.4018C7.94474 19.9903 8.48099 20.4603 9.11403 20.7575L8.57241 20.8256C8.40623 20.8462 8.24589 20.9 8.10092 20.9838C7.95595 21.0676 7.82932 21.1797 7.72856 21.3134C7.6278 21.4472 7.55496 21.5998 7.5144 21.7623C7.47383 21.9247 7.46635 22.0937 7.49241 22.2591C7.54371 22.5563 7.6985 22.8259 7.92939 23.0199C8.16029 23.214 8.4524 23.3202 8.75403 23.3196H13.7227C13.9562 23.3423 14.18 23.3521 14.3713 23.3521C15.0656 23.366 15.756 23.246 16.4048 22.9986C17.8989 22.4118 19.2129 21.4434 20.2157 20.1899C21.0079 19.2277 21.6628 18.1602 22.1616 17.018C22.7545 15.6976 23.0183 14.253 22.9303 12.8083V12.8083ZM4.44376 5.09585H4.19079C4.07239 5.08603 3.96201 5.03205 3.88155 4.94464C3.80109 4.85723 3.75643 4.74277 3.75643 4.62396C3.75643 4.50515 3.80109 4.39069 3.88155 4.30328C3.96201 4.21586 4.07239 4.16189 4.19079 4.15207H4.44376C4.50902 4.14665 4.57469 4.15483 4.63663 4.17609C4.69857 4.19735 4.75542 4.23122 4.8036 4.27557C4.85178 4.31991 4.89024 4.37377 4.91654 4.43374C4.94285 4.49371 4.95643 4.55848 4.95643 4.62396C4.95643 4.68944 4.94285 4.75421 4.91654 4.81418C4.89024 4.87415 4.85178 4.928 4.8036 4.97235C4.75542 5.0167 4.69857 5.05057 4.63663 5.07183C4.57469 5.09309 4.50902 5.10127 4.44376 5.09585V5.09585Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$o = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M23.2949 16.5782C21.8681 16.5782 20.5281 16.0278 19.5214 15.0282C18.5151 14.0292 17.961 12.6985 17.961 11.2815C17.961 10.8931 17.6461 10.5784 17.2579 10.5784C16.8695 10.5784 16.5547 10.8931 16.5547 11.2815C16.5547 12.6985 16.0005 14.0292 14.9941 15.0282C13.9874 16.0278 12.6475 16.5782 11.2207 16.5782C10.8323 16.5782 10.5176 16.8929 10.5176 17.2813C10.5176 17.6697 10.8323 17.9844 11.2207 17.9844C14.1617 17.9844 16.5547 20.3676 16.5547 23.2967C16.5547 23.6851 16.8695 23.9998 17.2579 23.9998C17.6461 23.9998 17.961 23.6851 17.961 23.2967C17.961 20.3676 20.3538 17.9844 23.2949 17.9844C23.6832 17.9844 23.998 17.6697 23.998 17.2813C23.998 16.8929 23.6832 16.5782 23.2949 16.5782V16.5782Z' fill='%231A0154'/%3e%3cpath d='M9.62036 11.0806C7.54962 11.0806 5.86487 9.40826 5.86487 7.35254C5.86487 6.96436 5.55011 6.64941 5.16174 6.64941C4.77338 6.64941 4.45862 6.96436 4.45862 7.35254C4.45862 9.40826 2.77386 11.0806 0.703125 11.0806C0.314758 11.0806 0 11.3955 0 11.7837C0 12.1721 0.314758 12.4868 0.703125 12.4868C2.77386 12.4868 4.45862 14.1644 4.45862 16.2264C4.45862 16.6146 4.77338 16.9295 5.16174 16.9295C5.55011 16.9295 5.86487 16.6146 5.86487 16.2264C5.86487 14.1644 7.54962 12.4868 9.62036 12.4868C10.0087 12.4868 10.3235 12.1721 10.3235 11.7837C10.3235 11.3955 10.0087 11.0806 9.62036 11.0806V11.0806Z' fill='%231A0154'/%3e%3cpath d='M10.7637 4.85889C12.2866 4.85889 13.5256 6.08844 13.5256 7.59961C13.5256 7.98779 13.8404 8.30273 14.2288 8.30273C14.6171 8.30273 14.9319 7.98779 14.9319 7.59961C14.9319 6.0835 16.171 4.8501 17.6938 4.8501C18.0822 4.8501 18.397 4.53516 18.397 4.14697C18.397 3.75861 18.0822 3.44385 17.6938 3.44385C16.171 3.44385 14.9319 2.21429 14.9319 0.703125C14.9319 0.314758 14.6171 0 14.2288 0C13.8404 0 13.5256 0.314758 13.5256 0.703125C13.5256 2.21924 12.2866 3.45264 10.7637 3.45264C10.3753 3.45264 10.0605 3.7674 10.0605 4.15576C10.0605 4.54413 10.3753 4.85889 10.7637 4.85889V4.85889Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$n = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_12192_169586)'%3e%3cpath d='M12.9686 9.5052L12.9646 9.51575H7.03486C6.17409 9.51575 5.37286 9.77487 4.70452 10.2189H2.8125C2.03709 10.2189 1.40625 9.58803 1.40625 8.81262C1.40625 8.03722 2.03709 7.40637 2.8125 7.40637H4.92188C5.31019 7.40637 5.625 7.09156 5.625 6.70325C5.625 6.31493 5.31019 6.00012 4.92188 6.00012H2.8125C1.26169 6.00012 0 7.26181 0 8.81262C0 10.3634 1.26169 11.6251 2.8125 11.6251H3.38039C3.01945 12.247 2.8125 12.9688 2.8125 13.7381V22.547C2.8125 22.9353 3.12731 23.2501 3.51562 23.2501H6.32812C6.71644 23.2501 7.03125 22.9353 7.03125 22.547V16.613L13.4531 17.1898V22.5939C13.4531 22.9822 13.7679 23.297 14.1562 23.297H16.9688C17.3571 23.297 17.6719 22.9822 17.6719 22.5939V15.9135L18.5383 11.5815L12.9686 9.5052Z' fill='%231A0154'/%3e%3cpath d='M23.2966 5.29655H21.1749C21.0608 4.22325 20.1523 3.37468 19.0333 3.37468H17.8535L17.423 1.2653C17.2822 0.575348 16.3211 0.500254 16.0751 1.16058L13.459 8.18686L18.8173 10.1843L18.9511 9.5153H20.4841C22.4226 9.5153 23.9997 7.93819 23.9997 5.99968C23.9997 5.61136 23.6849 5.29655 23.2966 5.29655Z' fill='%231A0154'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_12192_169586'%3e%3crect width='24' height='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img$m = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.89713 3.5625L4.49023 7.78125H5.82092L7.22683 3.5625H5.89713Z' fill='%231A0154'/%3e%3cpath d='M23.2956 3.5625H22.5924V2.85938C22.5924 2.47073 22.2779 2.15625 21.8893 2.15625C21.5007 2.15625 21.1862 2.47073 21.1862 2.85938V3.5625H8.70879L7.30273 7.78125H23.9987V4.26562C23.9987 3.87698 23.6842 3.5625 23.2956 3.5625Z' fill='%231A0154'/%3e%3cpath d='M2.10938 3.5625C1.72073 3.5625 1.40625 3.87698 1.40625 4.26562C1.40625 4.65356 1.09041 4.96875 0.703125 4.96875C0.314484 4.96875 0 5.28323 0 5.67188V7.78125H3.00853L4.41478 3.5625H2.10938Z' fill='%231A0154'/%3e%3cpath d='M0 9.1875V9.89062C0 10.2793 0.314484 10.5938 0.703125 10.5938C1.09041 10.5938 1.40625 10.9089 1.41309 11.1973L0.245578 19.4357C0.0646406 20.7038 1.044 21.8438 2.325 21.8438H5.09081C6.14827 21.8438 7.04775 21.052 7.18369 20.0022L7.66847 16.2188H10.5469C11.71 16.2188 12.6562 15.2725 12.6562 14.1094V12H20.4844C20.7508 12 20.9939 11.8496 21.1133 11.6114L22.3253 9.1875C5.31225 9.1875 9.10641 9.1875 0 9.1875ZM8.4375 14.8125C7.66158 14.8125 7.03125 14.1815 7.03125 13.4062C7.03125 12.631 7.66158 12 8.4375 12H8.48419C8.29055 12.6206 8.25586 13.2853 8.42653 13.9253C8.51081 14.2436 8.65313 14.5355 8.8193 14.8125H8.4375ZM11.25 14.1094C11.25 14.4437 11.0107 14.7108 10.6981 14.7819C10.2537 14.5044 9.92166 14.0757 9.78469 13.5649C9.64359 13.0333 9.72905 12.4728 10.002 12H11.25V14.1094Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$l = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_12192_169652)'%3e%3cpath d='M18.75 9H18V6C18 2.691 15.309 0 12 0C8.691 0 6 2.691 6 6V9H5.25C4.01 9 3 10.009 3 11.25V21.75C3 22.991 4.01 24 5.25 24H18.75C19.99 24 21 22.991 21 21.75V11.25C21 10.009 19.99 9 18.75 9ZM8 6C8 3.794 9.794 2 12 2C14.206 2 16 3.794 16 6V9H8V6ZM13 16.722V19C13 19.552 12.553 20 12 20C11.447 20 11 19.552 11 19V16.722C10.405 16.375 10 15.737 10 15C10 13.897 10.897 13 12 13C13.103 13 14 13.897 14 15C14 15.737 13.595 16.375 13 16.722Z' fill='%231A0154'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_12192_169652'%3e%3crect width='24' height='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img$k = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 0C5.38331 0 0 5.38331 0 12C0 18.6167 5.38331 24 12 24C18.6167 24 24 18.6167 24 12C24 5.38331 18.6167 0 12 0ZM12 22C6.48586 22 2.00002 17.5141 2.00002 12C2.00002 9.6023 2.84962 7.40034 4.26169 5.67572L6.00136 7.41539L5.02589 10.3418C4.95459 10.5557 5.03517 10.791 5.22267 10.916L6.41456 11.7109L5.02102 16.3564C4.99514 16.4423 4.99317 16.5342 5.01516 16.6211L5.36658 18.0269C5.15667 18.0863 5.00002 18.271 5.00002 18.5C5.00002 18.7763 5.22366 19 5.50003 19H9.50002C9.72314 19 9.91945 18.8515 9.98095 18.6377L11.0201 15H12.1523C12.5597 15 12.9476 14.8944 13.3005 14.7146L18.3243 19.7383C16.5997 21.1504 14.3977 22 12 22ZM11.3058 14L11.5903 13.0043L12.5329 13.947C12.4094 13.9783 12.283 14 12.1523 14H11.3058ZM13.4081 11.9941L13.8616 11.9926L13.7705 12.3565L13.4081 11.9941ZM19.7384 18.3243L14.583 13.169C14.593 13.1351 14.6135 13.1056 14.622 13.0713L14.908 11.9283L19.5981 10.9902C19.8315 10.9433 20 10.7383 20 10.5V9.50002H20.5C20.7764 9.50002 21 9.27637 21 9V8.00002C21 7.72364 20.7764 7.5 20.5 7.5H20C20 7.22363 19.7763 6.99998 19.5 6.99998H8.41406L5.67572 4.26164C7.40034 2.84963 9.6023 2.00002 12 2.00002C17.5141 2.00002 22 6.48586 22 12C22 14.3977 21.1504 16.5997 19.7384 18.3243Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$j = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M11.3613 7.66479L12.8476 6.17853L17.8185 11.1494L16.3322 12.6357L11.3613 7.66479Z' fill='%231A0154'/%3e%3cpath d='M16.8223 8.1665L18.3188 6.66996L20.3071 8.65822L18.8105 10.1548L16.8223 8.1665Z' fill='%231A0154'/%3e%3cpath d='M13.8457 5.18408L15.3423 3.68745L17.3309 5.67599L15.8342 7.17263L13.8457 5.18408Z' fill='%231A0154'/%3e%3cpath d='M15.3419 13.6294L10.3703 8.65784L0 19.0286L4.97136 23.9999L15.3419 13.6294ZM11.3644 11.6413L12.3587 12.6355L11.3644 13.6298L10.3701 12.6355L11.3644 11.6413ZM9.3759 13.6298L10.3702 14.6241L9.3759 15.6184L8.38163 14.6241L9.3759 13.6298Z' fill='%231A0154'/%3e%3cpath d='M19.8071 0L19.6472 0.480659C19.356 1.35338 18.8582 2.15884 18.2079 2.8091L17.8276 3.18883C17.5646 3.45457 17.1011 3.45457 16.834 3.18883L20.8117 7.16658C20.5371 6.89259 20.5371 6.44629 20.8104 6.17301L21.1915 5.79262C21.841 5.14236 22.6465 4.64455 23.5199 4.3527L24.0005 4.19267V2.40053L21.6 0L19.8071 0Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$i = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9H15V22H13V16H11V22H9V9H3V7H21V9Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$h = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M20.9648 1.11245C20.9646 1.07736 20.9629 1.04235 20.9595 1.00734C20.9578 0.989761 20.9545 0.972628 20.9519 0.955271C20.9492 0.936649 20.9471 0.917877 20.9434 0.899403C20.9395 0.879738 20.9341 0.860668 20.9292 0.841449C20.9251 0.825434 20.9216 0.809344 20.9169 0.793477C20.9112 0.774556 20.9041 0.756232 20.8974 0.737758C20.8917 0.721966 20.8865 0.706025 20.8801 0.690382C20.8728 0.672876 20.8643 0.655967 20.8562 0.638908C20.8487 0.623042 20.8417 0.606952 20.8334 0.591383C20.8243 0.574548 20.8141 0.558607 20.8043 0.542294C20.7953 0.527396 20.7869 0.512274 20.7772 0.497674C20.7647 0.479051 20.7509 0.461397 20.7374 0.443519C20.7289 0.432345 20.7212 0.420799 20.7122 0.409849C20.6652 0.352491 20.6127 0.2999 20.5554 0.252971C20.5451 0.244554 20.5341 0.237254 20.5236 0.229283C20.5051 0.215204 20.4868 0.200902 20.4675 0.188015C20.4536 0.178778 20.4392 0.170808 20.4251 0.162241C20.408 0.151887 20.3912 0.141235 20.3736 0.131774C20.359 0.124027 20.344 0.117472 20.3292 0.110396C20.311 0.10168 20.2931 0.0927412 20.2744 0.0849941C20.2601 0.0791093 20.2456 0.0744909 20.2312 0.069202C20.2113 0.0619019 20.1915 0.0543039 20.1711 0.0481956C20.1572 0.0440241 20.143 0.04097 20.129 0.0373944C20.1078 0.0318821 20.0867 0.0260718 20.0651 0.0217513C20.0499 0.0187717 20.0345 0.0170584 20.0192 0.0147492C19.9985 0.0115461 19.9781 0.00782154 19.957 0.0057358C19.9328 0.00342658 19.9086 0.00283065 19.8842 0.00208575C19.8719 0.00141533 19.8599 0 19.8476 0H16.3198C15.7027 0 15.2024 0.500281 15.2024 1.11736C15.2024 1.73445 15.7027 2.23473 16.3198 2.23473H17.1502L15.4669 3.91807C14.1674 2.94023 12.5526 2.35987 10.8047 2.35987C6.52059 2.35987 3.03516 5.8453 3.03516 10.1295C3.03516 14.0342 5.93069 17.2749 9.68727 17.8184L9.68735 19.2707H8.31023C7.69315 19.2707 7.19287 19.771 7.19287 20.3881C7.19287 21.0052 7.69315 21.5054 8.31023 21.5054H9.68742L9.6875 22.8826C9.6875 23.4997 10.1878 24 10.8049 24C11.4219 24 11.9222 23.4997 11.9222 22.8826L11.9222 21.5054H13.2993C13.9163 21.5054 14.4166 21.0052 14.4166 20.3881C14.4166 19.771 13.9163 19.2707 13.2993 19.2707H11.9222L11.9221 17.8184C15.6787 17.275 18.5743 14.0342 18.5743 10.1295C18.5743 8.39751 18.0044 6.79618 17.0426 5.50279L18.7303 3.81505V4.64525C18.7303 5.26234 19.2305 5.76262 19.8476 5.76262C20.4647 5.76262 20.965 5.26234 20.965 4.64525V1.11736C20.965 1.11572 20.9648 1.11416 20.9648 1.11245ZM10.8047 15.6643C7.75282 15.6643 5.26989 13.1814 5.26989 10.1295C5.26989 7.07753 7.75274 4.5946 10.8047 4.5946C13.8566 4.5946 16.3395 7.07753 16.3395 10.1295C16.3395 13.1814 13.8566 15.6643 10.8047 15.6643Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$g = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M20 16H3.99998C1.8 16 0 17.8 0 20C0 22.2001 1.8 24 3.99998 24H20C22.2 24 24 22.2 24 20C24 17.8 22.2 16 20 16Z' fill='%231A0154'/%3e%3cpath d='M15.9019 9.99976H8.00194C5.80195 9.99976 4.00195 11.7997 4.00195 13.9997C4.00195 14.2997 4.10194 14.6997 4.10194 14.9997H19.8019C19.9019 14.6997 19.9019 14.2997 19.9019 13.9997C19.9019 11.7997 18.1019 9.99976 15.9019 9.99976Z' fill='%231A0154'/%3e%3cpath d='M16.0977 6.90059C15.2976 3.80061 11.5977 2.20058 11.3976 2.10059C10.5976 1.80059 9.69764 2.70059 10.0977 3.50061C10.4976 4.50059 10.0977 5.70059 9.29765 6.30059C8.49764 7.00058 8.09766 8.00061 8.09766 9.00059H16.0977C16.2976 8.30061 16.2976 7.60058 16.0977 6.90059Z' fill='%231A0154'/%3e%3cpath d='M19 4.99997C19.5523 4.99997 20 4.55226 20 3.99998C20 3.44771 19.5523 3 19 3C18.4477 3 18 3.44771 18 3.99998C18 4.55226 18.4477 4.99997 19 4.99997Z' fill='%231A0154'/%3e%3cpath d='M6.99998 1.99997C7.55226 1.99997 7.99997 1.55226 7.99997 0.999984C7.99997 0.447708 7.55226 0 6.99998 0C6.44771 0 6 0.447708 6 0.999984C6 1.55226 6.44771 1.99997 6.99998 1.99997Z' fill='%231A0154'/%3e%3cpath d='M2.99803 9.00009C3.55031 9.00009 3.99802 8.55238 3.99802 8.00011C3.99802 7.44783 3.55031 7.00012 2.99803 7.00012C2.44576 7.00012 1.99805 7.44783 1.99805 8.00011C1.99805 8.55238 2.44576 9.00009 2.99803 9.00009Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$f = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z' fill='%231A0154'/%3e%3cpath d='M20 13V4.83C20 3.27 18.73 2 17.17 2C16.42 2 15.7 2.3 15.17 2.83L13.92 4.08C13.76 4.03 13.59 4 13.41 4C13.01 4 12.64 4.12 12.33 4.32L15.09 7.08C15.29 6.77 15.41 6.4 15.41 6C15.41 5.82 15.38 5.66 15.34 5.49L16.59 4.24C16.74 4.09 16.95 4 17.17 4C17.63 4 18 4.37 18 4.83V13H11.15C10.85 12.79 10.58 12.55 10.33 12.28L8.93 10.73C8.74 10.52 8.5 10.35 8.24 10.23C7.93 10.08 7.59 10 7.24 10C6 10.01 5 11.01 5 12.25V13H2V19C2 20.1 2.9 21 4 21C4 21.55 4.45 22 5 22H19C19.55 22 20 21.55 20 21C21.1 21 22 20.1 22 19V13H20Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$e = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M15.9908 3.12234C16.8171 3.07945 17.4755 2.40202 17.4755 1.5652C17.4755 0.700734 16.7747 0 15.9102 0H8.08416C7.21969 0 6.51891 0.700734 6.51891 1.5652C6.51891 2.40202 7.17731 3.07945 8.00353 3.1223C7.51491 7.54125 5.73633 7.83234 5.73633 12.2772V21.6522C5.73633 22.9468 6.78952 24 8.08416 24H15.9103C17.2049 24 18.2581 22.9468 18.2581 21.6522V12.2772C18.258 7.82489 16.4806 7.55227 15.9908 3.12234ZM11.4862 9.67533C10.4021 8.95256 9.11644 8.67994 7.89605 8.83087C8.0378 8.42897 8.20247 8.03531 8.39292 7.65436C9.02958 6.38025 9.42553 4.64616 9.57755 3.13041H14.4169C14.5688 4.64616 14.9648 6.38025 15.6015 7.65436C15.8668 8.18484 16.0851 8.739 16.2554 9.30764C15.6817 9.59231 13.7974 11.2162 11.4862 9.67533Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$d = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 0C5.40894 0 0 5.40894 0 12C0 18.5911 5.40894 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40894 18.5911 0 12 0ZM12 1.40625C14.6552 1.40625 17.0775 2.44684 18.9335 4.07208L4.07208 18.9335C2.44684 17.0775 1.40625 14.6552 1.40625 12C1.40625 6.1842 6.1842 1.40625 12 1.40625V1.40625ZM12 22.5938C9.34479 22.5938 6.92249 21.5532 5.06653 19.9279L19.9279 5.06653C21.5532 6.92249 22.5938 9.34479 22.5938 12C22.5938 17.8158 17.8158 22.5938 12 22.5938V22.5938Z'/%3e%3cpath d='M12 8.48438C13.183 8.48438 14.1094 7.24915 14.1094 5.67188C14.1094 4.0946 13.183 2.85938 12 2.85938C10.817 2.85938 9.89062 4.0946 9.89062 5.67188C9.89062 7.24915 10.817 8.48438 12 8.48438Z' /%3e%3cpath d='M6.375 11.2969C7.55804 11.2969 8.48438 10.0616 8.48438 8.48438C8.48438 6.9071 7.55804 5.67188 6.375 5.67188C5.19196 5.67188 4.26562 6.9071 4.26562 8.48438C4.26562 10.0616 5.19196 11.2969 6.375 11.2969Z'/%3e%3cpath d='M8.37891 18.6027C8.60394 18.7076 8.84802 18.7821 9.11133 18.8109C10.131 18.9207 11.0469 18.3969 11.4521 17.474C11.6287 17.0715 11.8806 16.9219 11.9987 16.9219C12.1291 16.9219 12.388 17.1025 12.5555 17.5042C12.9078 18.3489 13.7291 18.8795 14.6664 18.8795C14.7014 18.8795 14.7363 18.8788 14.7713 18.8775C15.7128 18.8376 16.4702 18.2767 16.7476 17.4123C16.8622 17.0545 16.9206 16.6528 16.9206 16.2188C16.9206 14.816 16.2918 13.0425 15.2523 11.7292L8.37891 18.6027Z'/%3e%3cpath d='M10.9528 10.0647C9.61981 10.51 8.5318 11.7601 7.85156 13.1658L10.9528 10.0647Z'/%3e%3cpath d='M19.5766 7.40576L16.3047 10.6777C16.6645 11.0607 17.1179 11.2969 17.6245 11.2969C18.8076 11.2969 19.7339 10.0617 19.7339 8.48444C19.7339 8.09991 19.6769 7.73682 19.5766 7.40576Z'/%3e%3c/svg%3e";

var img$c = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_12192_169521)'%3e%3cpath d='M21.4289 5.93784C21.6094 5.74904 21.6601 5.47033 21.5573 5.23079C21.4546 4.99061 21.2183 4.83456 20.9575 4.83456H15.9908L16.746 3.21559C17.4666 3.44293 18.2404 3.15137 18.5468 2.49698C18.8518 1.84259 18.5776 1.06297 17.9405 0.656458L18.1024 0.309675C18.1531 0.200502 18.1062 0.0714214 17.997 0.0206883C17.8879 -0.0300449 17.7588 0.0168351 17.708 0.126008L17.5462 0.472791C16.825 0.245455 16.0518 0.537011 15.7462 1.1914C15.4405 1.8458 15.7153 2.62542 16.3524 3.03193L15.5105 4.83392H3.04295C2.78158 4.83392 2.54589 4.98997 2.44314 5.23015C2.34039 5.47033 2.39113 5.74904 2.57158 5.9372L11.4049 15.1661V22.8583H8.95112C8.6358 22.8583 8.38021 23.1139 8.38021 23.4292C8.38021 23.7445 8.63516 24.0008 8.95112 24.0008H15.05C15.3653 24.0008 15.6209 23.7452 15.6209 23.4292C15.6209 23.1146 15.366 22.8583 15.05 22.8583H12.5956V15.1668L21.4289 5.93784ZM14.9017 6.13949L14.0572 7.95112H7.25958L12.0009 12.9043L16.7422 7.95112H14.5375L15.382 6.13949H19.4298L12.0009 13.901L4.57073 6.13949H14.9017Z' fill='%231A0154'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_12192_169521'%3e%3crect width='24' height='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img$b = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M8.36476 9.64579C6.97776 9.01781 6.01282 7.62159 6.01282 6C6.01282 3.79086 7.80368 2 10.0128 2C11.2522 2 12.36 2.56369 13.0937 3.44868C10.4237 3.80932 8.31287 6.14377 8.31287 8.90039C8.31287 9.15279 8.33056 9.40166 8.36476 9.64579Z' fill='%231A0154'/%3e%3cpath d='M4.93705 19H3.01281C2.41281 19 1.91281 18.5 2.01281 17.9C2.55485 14.3767 5.30046 11.588 8.77505 11.0821C9.19269 12.027 9.87049 12.839 10.7136 13.4232C8.08446 14.3352 5.93381 16.3726 4.93705 19Z' fill='%231A0154'/%3e%3cpath d='M13.8129 4.90039C16.0129 4.90039 17.8129 6.70039 17.8129 8.90039C17.8129 11.1004 16.0129 12.9004 13.8129 12.9004C11.6129 12.9004 9.81287 11.1004 9.81287 8.90039C9.81287 6.70039 11.6129 4.90039 13.8129 4.90039Z' fill='%231A0154'/%3e%3cpath d='M13.8128 14.4004C17.8128 14.4004 21.2128 17.4004 21.7128 21.3004C21.8128 21.9004 21.3128 22.4004 20.7128 22.4004H6.91283C6.31283 22.4004 5.81283 21.9004 5.91283 21.3004C6.51283 17.4004 9.81282 14.4004 13.8128 14.4004Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$a = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.15547 17.7944H5.60401L10.534 21.5111C11.3043 22.0888 12.3829 21.5496 12.3829 20.5867V3.4088C12.3829 2.46517 11.2851 1.90669 10.534 2.48442L5.60401 6.20117H1.15547C0.51996 6.20117 0 6.72113 0 7.35664V16.6583C0 17.2744 0.51996 17.7944 1.15547 17.7944Z' fill='%231A0154'/%3e%3cpath d='M23.5719 7.81929C23.052 7.29933 22.1854 7.29933 21.6654 7.81929L19.393 10.0917L17.1206 7.81929C16.6006 7.29933 15.734 7.29933 15.214 7.81929C14.6943 8.33925 14.6943 9.20585 15.214 9.72581L17.4867 11.9982L15.214 14.2706C14.6943 14.7906 14.6943 15.6572 15.214 16.1772C15.4837 16.4466 15.8303 16.5816 16.1769 16.5816C16.5238 16.5816 16.8702 16.4468 17.1398 16.1772L19.4124 13.9046L21.6847 16.1772C21.9543 16.4466 22.3011 16.5816 22.6475 16.5816C22.9944 16.5816 23.341 16.4468 23.6104 16.1772C24.1306 15.6572 24.1306 14.7906 23.6104 14.2706L21.2995 11.9982L23.5721 9.72581C24.0919 9.20585 24.0919 8.33925 23.5719 7.81929Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$9 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.15547 17.7944H5.60401L10.534 21.5111C11.3043 22.0888 12.3829 21.5496 12.3829 20.5867V3.4088C12.3829 2.46517 11.2851 1.90669 10.534 2.48442L5.60401 6.20117H1.15547C0.51996 6.20117 0 6.72113 0 7.35664V16.6583C0 17.2744 0.51996 17.7944 1.15547 17.7944Z' fill='%231A0154'/%3e%3cline x1='15.75' y1='7.49951' x2='15.75' y2='16.4995' stroke='%231A0154' stroke-width='1.5' stroke-linecap='round'/%3e%3c/svg%3e";

var img$8 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M6.65678 10.3133C8.67637 10.3133 10.3136 8.67613 10.3136 6.65654C10.3136 4.63695 8.67637 2.99976 6.65678 2.99976C4.6372 2.99976 3 4.63695 3 6.65654C3 8.67613 4.6372 10.3133 6.65678 10.3133Z' fill='%231A0154'/%3e%3cpath d='M17.9361 20.9995C19.9557 20.9995 21.5929 19.3623 21.5929 17.3427C21.5929 15.3231 19.9557 13.6859 17.9361 13.6859C15.9165 13.6859 14.2793 15.3231 14.2793 17.3427C14.2793 19.3623 15.9165 20.9995 17.9361 20.9995Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$7 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M6.65682 10.3134C8.67643 10.3134 10.3136 8.67619 10.3136 6.65658C10.3136 4.63697 8.67643 2.99976 6.65682 2.99976C4.63722 2.99976 3 4.63697 3 6.65658C3 8.67619 4.63722 10.3134 6.65682 10.3134Z' fill='%231A0154'/%3e%3cpath d='M17.9361 10.3134C19.9557 10.3134 21.5929 8.67619 21.5929 6.65658C21.5929 4.63697 19.9557 2.99976 17.9361 2.99976C15.9165 2.99976 14.2793 4.63697 14.2793 6.65658C14.2793 8.67619 15.9165 10.3134 17.9361 10.3134Z' fill='%231A0154'/%3e%3cpath d='M6.65682 20.9994C8.67643 20.9994 10.3136 19.3622 10.3136 17.3426C10.3136 15.323 8.67643 13.6858 6.65682 13.6858C4.63722 13.6858 3 15.323 3 17.3426C3 19.3622 4.63722 20.9994 6.65682 20.9994Z' fill='%231A0154'/%3e%3cpath d='M17.9361 20.9994C19.9557 20.9994 21.5929 19.3622 21.5929 17.3426C21.5929 15.323 19.9557 13.6858 17.9361 13.6858C15.9165 13.6858 14.2793 15.323 14.2793 17.3426C14.2793 19.3622 15.9165 20.9994 17.9361 20.9994Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 10.15 4.63 8.45 5.69 7.1L16.9 18.31C15.55 19.37 13.85 20 12 20ZM18.31 16.9L7.1 5.69C8.45 4.63 10.15 4 12 4C16.42 4 20 7.58 20 12C20 13.85 19.37 15.55 18.31 16.9Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.6568 10.3133C14.6764 10.3133 16.3136 8.67613 16.3136 6.65654C16.3136 4.63695 14.6764 2.99976 12.6568 2.99976C10.6372 2.99976 9 4.63695 9 6.65654C9 8.67613 10.6372 10.3133 12.6568 10.3133Z' fill='%231A0154'/%3e%3cpath d='M6.65678 20.9995C8.67637 20.9995 10.3136 19.3623 10.3136 17.3427C10.3136 15.3231 8.67637 13.6859 6.65678 13.6859C4.6372 13.6859 3 15.3231 3 17.3427C3 19.3623 4.6372 20.9995 6.65678 20.9995Z' fill='%231A0154'/%3e%3cpath d='M17.9361 20.9995C19.9557 20.9995 21.5929 19.3623 21.5929 17.3427C21.5929 15.3231 19.9557 13.6859 17.9361 13.6859C15.9165 13.6859 14.2793 15.3231 14.2793 17.3427C14.2793 19.3623 15.9165 20.9995 17.9361 20.9995Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M17 8C16.4488 8 16 7.55127 16 7.00002C16 5.897 15.1031 5 14 5H12.5C12.2236 5 12 5.22364 12 5.50002C12 5.77639 12.2236 6.00003 12.5 6.00003H14C14.5513 6.00003 15 6.44877 15 7.00002C15 8.10303 15.897 8.99998 17 8.99998C17.5513 8.99998 18 9.44872 18 9.99997V11.5C18 11.7763 18.2236 12 18.5 12C18.7764 12 19 11.7763 19 11.5V9.99997C19 8.89695 18.103 8 17 8Z' fill='%231A0154'/%3e%3cpath d='M16.5 11H15.5001C15.2242 11 15 10.7759 15 10.5C15 9.67287 14.3272 9.00002 13.5 9.00002C13.2242 9.00002 13 8.77591 13 8.50001V7.50002C13 7.22364 12.7764 7 12.5 7C12.2236 7 12 7.22364 12 7.50002V8.50001C12 9.32717 12.6728 10 13.5 10C13.7759 10 14 10.2241 14 10.5C14 11.3272 14.6729 12 15.5 12H16.5C16.7764 12 17.0001 11.7764 17.0001 11.5C17.0001 11.2237 16.7764 11 16.5 11Z' fill='%231A0154'/%3e%3cpath d='M12 0C5.38331 0 0 5.38331 0 12C0 18.6167 5.38331 24 12 24C18.6167 24 24 18.6167 24 12C24 5.38331 18.6167 0 12 0ZM12 22C6.48586 22 2.00002 17.5141 2.00002 12C2.00002 9.6023 2.84962 7.40034 4.26169 5.67572L11.586 13H5.49998C5.22361 13 4.99997 13.2236 4.99997 13.5V15.5C4.99997 15.7764 5.22361 16 5.49998 16H14.5859L18.3242 19.7384C16.5997 21.1504 14.3977 22 12 22ZM19.7384 18.3243L17.4141 16H18.5C18.7764 16 19 15.7763 19 15.5V13.5C19 13.2236 18.7764 13 18.5 13H14.4141L5.67572 4.26164C7.40034 2.84963 9.6023 2.00002 12 2.00002C17.5141 2.00002 22 6.48586 22 12C22 14.3977 21.1504 16.5997 19.7384 18.3243ZM17 15V14H18V15H17Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_12192_169540)'%3e%3cpath d='M11.2961 22.5261V15.4873L8.51953 22.5261H11.2961Z' fill='%231A0154'/%3e%3cpath d='M12.7031 22.5261H15.4797L12.7031 15.4873V22.5261Z' fill='%231A0154'/%3e%3cpath d='M12.6524 11.5308L16.9914 22.5256H19.182C19.6606 22.5256 20.0996 22.2447 20.3003 21.8102L21.2268 19.8037L22.1249 21.2133L22.7039 22.1221C22.8379 22.3325 23.0652 22.4475 23.2975 22.4475C23.4268 22.4475 23.5576 22.4119 23.6747 22.3373C23.9247 22.178 24.0394 21.887 23.9872 21.6126C23.9953 21.5697 24 21.5257 24 21.4804V18.0029C24 17.6146 23.6852 17.2998 23.2969 17.2998C22.9086 17.2998 22.5938 17.6146 22.5938 18.0029V19.332L12.8337 4.01276L13.1927 3.44932L13.7623 2.55527C13.9709 2.22776 13.8746 1.79313 13.5471 1.58449C13.2195 1.37576 12.7848 1.47218 12.5763 1.7997L12.2917 2.24637L12 2.7042L11.7083 2.24637L11.4237 1.7997C11.2151 1.47218 10.7805 1.37585 10.4529 1.58449C10.1255 1.79313 10.0291 2.2278 10.2377 2.55527L10.8073 3.44932L11.1663 4.01276L1.40625 19.332V18.0029C1.40625 17.6146 1.09144 17.2998 0.703125 17.2998C0.314812 17.2998 0 17.6146 0 18.0029V21.4804C0 21.5257 0.0046875 21.5697 0.0128437 21.6126C-0.0394219 21.8871 0.0753281 22.178 0.325313 22.3373C0.442406 22.4119 0.573188 22.4475 0.702469 22.4475C0.934734 22.4475 1.16208 22.3324 1.29614 22.1221L1.98375 21.0428L2.83566 19.7057L4.1078 21.9096C4.32713 22.2896 4.73592 22.5257 5.17462 22.5257H7.00866L11.346 11.5302C11.447 11.2685 11.7027 11.0835 12 11.0835C12.2973 11.0834 12.5513 11.2691 12.6524 11.5308V11.5308Z' fill='%231A0154'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_12192_169540'%3e%3crect width='24' height='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M2 16H17V19H2V16ZM20.5 16H22V19H20.5V16ZM18 16H19.5V19H18V16ZM18.85 7.73C19.47 7.12 19.85 6.28 19.85 5.35C19.85 3.5 18.35 2 16.5 2V3.5C17.52 3.5 18.35 4.33 18.35 5.35C18.35 6.37 17.52 7.2 16.5 7.2V8.7C18.74 8.7 20.5 10.53 20.5 12.77V15H22V12.76C22 10.54 20.72 8.62 18.85 7.73V7.73ZM16.03 10.2H14.5C13.48 10.2 12.65 9.22 12.65 8.2C12.65 7.18 13.48 6.45 14.5 6.45V4.95C12.65 4.95 11.15 6.45 11.15 8.3C11.15 10.15 12.65 11.65 14.5 11.65H16.03C17.08 11.65 18 12.39 18 13.7V15H19.5V13.36C19.5 11.55 17.9 10.2 16.03 10.2V10.2Z' fill='%231A0154'/%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_12192_169549)'%3e%3cpath d='M11.5078 7.52893L12.9982 6.03853L17.9615 11.0018L16.4711 12.4922L11.5078 7.52893Z' fill='%231A0154'/%3e%3cpath d='M20.9228 10.0372C21.062 10.6702 21.1875 11.3257 21.1875 12C21.1875 14.0132 20.4784 15.8705 19.3712 17.3824L6.61758 4.62877C8.12953 3.52163 9.98677 2.8125 12 2.8125C12.6741 2.8125 13.3294 2.93789 13.9624 3.07706L16.2138 0.825656C14.9017 0.330375 13.4855 0 12 0C5.3985 0 0 5.39841 0 12C0 13.4855 0.330375 14.9017 0.825609 16.2139L3.07702 13.9625C2.93789 13.3294 2.8125 12.6741 2.8125 12C2.8125 9.98677 3.52163 8.12953 4.62877 6.61758L17.3825 19.3712C15.8705 20.4784 14.0133 21.1875 12 21.1875C11.3258 21.1875 10.6704 21.0621 10.0374 20.9229L7.78603 23.1744C9.09825 23.6696 10.5144 24 12 24C18.6015 24 24 18.6015 24 12C24 10.5143 23.6695 9.09797 23.1742 7.78561L20.9228 10.0372Z' fill='%231A0154'/%3e%3cpath d='M19.81 0L19.6413 0.478078C19.36 1.34995 18.8069 2.21245 18.16 2.85938L17.7803 3.23902C17.5197 3.49959 17.0745 3.50156 16.8047 3.25388L20.7475 7.19667C20.4987 6.91439 20.5005 6.48127 20.7615 6.22036L21.1412 5.84062C21.7882 5.1937 22.6506 4.64063 23.5224 4.35933L24.0006 4.19058V2.40464L21.5959 0H19.81Z' fill='%231A0154'/%3e%3cpath d='M7.52583 11.5035L0 19.0287L4.97198 24.0006L12.4971 16.4748L7.52583 11.5035ZM7.5308 15.4756L8.52506 14.4813L9.51933 15.4756L8.52506 16.4699L7.5308 15.4756Z' fill='%231A0154'/%3e%3cpath d='M20.2646 8.70505L18.2751 6.71558L16.9688 8.02194L18.9549 10.0081L20.2646 8.70505Z' fill='%231A0154'/%3e%3cpath d='M13.9922 5.04218L15.9784 7.02837L17.2847 5.72201L15.2953 3.73254L13.9922 5.04218Z' fill='%231A0154'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_12192_169549'%3e%3crect width='24' height='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_12192_169568)'%3e%3cpath d='M11.2961 22.5261V15.4873L8.51953 22.5261H11.2961Z' fill='%231A0154'/%3e%3cpath d='M12.7031 22.5261H15.4797L12.7031 15.4873V22.5261Z' fill='%231A0154'/%3e%3cpath d='M12.6524 11.5308L16.9914 22.5256H19.182C19.6606 22.5256 20.0996 22.2447 20.3003 21.8102L21.2268 19.8037L22.1249 21.2133L22.7039 22.1221C22.8379 22.3325 23.0652 22.4475 23.2975 22.4475C23.4268 22.4475 23.5576 22.4119 23.6747 22.3373C23.9247 22.178 24.0394 21.887 23.9872 21.6126C23.9953 21.5697 24 21.5257 24 21.4804V18.0029C24 17.6146 23.6852 17.2998 23.2969 17.2998C22.9086 17.2998 22.5938 17.6146 22.5938 18.0029V19.332L12.8337 4.01276L13.1927 3.44932L13.7623 2.55527C13.9709 2.22776 13.8746 1.79313 13.5471 1.58449C13.2195 1.37576 12.7848 1.47218 12.5763 1.7997L12.2917 2.24637L12 2.7042L11.7083 2.24637L11.4237 1.7997C11.2151 1.47218 10.7805 1.37585 10.4529 1.58449C10.1255 1.79313 10.0291 2.2278 10.2377 2.55527L10.8073 3.44932L11.1663 4.01276L1.40625 19.332V18.0029C1.40625 17.6146 1.09144 17.2998 0.703125 17.2998C0.314812 17.2998 0 17.6146 0 18.0029V21.4804C0 21.5257 0.0046875 21.5697 0.0128437 21.6126C-0.0394219 21.8871 0.0753281 22.178 0.325313 22.3373C0.442406 22.4119 0.573188 22.4475 0.702469 22.4475C0.934734 22.4475 1.16208 22.3324 1.29614 22.1221L1.98375 21.0428L2.83566 19.7057L4.1078 21.9096C4.32713 22.2896 4.73592 22.5257 5.17462 22.5257H7.00866L11.346 11.5302C11.447 11.2685 11.7027 11.0835 12 11.0835C12.2973 11.0834 12.5513 11.2691 12.6524 11.5308V11.5308Z' fill='%231A0154'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_12192_169568'%3e%3crect width='24' height='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

const iconSet = {
    icons: {
        allInForALoudHouse: img$u,
        anyPets: img$t,
        average: img$s,
        cagedAnimalsOnly: img$r,
        casualDrinkingIsFine: img$q,
        catsOnly: img$p,
        clean: img$o,
        dogsOnly: img$n,
        firearmsAny: img$m,
        firearmsMustBeSecurelyLockedAndStored: img$l,
        firearmsNone: img$k,
        group: img$j,
        human: img$i,
        intersex: img$h,
        messy: img$g,
        neatFreak: img$f,
        noDrinking: img$e,
        noPets: img$d,
        peopleCanDoWhatTheyWant: img$c,
        people: img$b,
        quiet: img$a,
        someNoiseIsOkay: img$9,
        sharingAFewThings: img$8,
        sharingManyThings: img$7,
        sharingNothing: img$6,
        sharingSomeThings: img$5,
        smokingNoSmoking: img$4,
        smokingOutdoorsOnly: img$3,
        smoking: img$2,
        vapingNoVaping: img$1,
        vapingOutdoorsOnly: img,
    },
    defaultIcon: img$7,
};

var iconSets = /*#__PURE__*/Object.freeze({
  __proto__: null,
  roundedEmojis: iconSet$1,
  chips: iconSet
});

const defaultIconSet = 'roundedEmojis';
function useIcon(iconRef) {
    let iconId, iconSetName;
    const divider = iconRef.lastIndexOf('/');
    if (divider === -1) {
        iconId = iconRef;
    }
    else {
        iconSetName = iconRef.substring(0, divider);
        iconId = iconRef.substring(divider + 1);
    }
    if (!iconSetName) {
        iconSetName = defaultIconSet;
    }
    let iconSet = iconSets[iconSetName];
    if (!iconSet) {
        iconSet = iconSets[defaultIconSet];
    }
    const selectedIcon = iconSet.icons[iconId] || iconSet.defaultIcon;
    // `src` can be used as img src
    return { src: selectedIcon };
}
const defaultIcons = iconSets[defaultIconSet];

function Icon({ iconRef, className = '' }) {
    const { src } = useIcon(iconRef);
    // TODO: add appropriate alt text
    // Eventually, useIcon could return an optional alt textif configured
    // and Icon props could include optional alt text.
    // The order of priority would be: prop, icon config, empty.
    return jsx("img", { className: className, src: src, alt: "" }, void 0);
}

function n(n){for(var t=arguments.length,r=Array(t>1?t-1:0),e=1;e<t;e++)r[e-1]=arguments[e];if("production"!==process.env.NODE_ENV){var i=Y[n],o=i?"function"==typeof i?i.apply(null,r):i:"unknown error nr: "+n;throw Error("[Immer] "+o)}throw Error("[Immer] minified error nr: "+n+(r.length?" "+r.map((function(n){return "'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function t(n){return !!n&&!!n[Q]}function r(n){return !!n&&(function(n){if(!n||"object"!=typeof n)return !1;var t=Object.getPrototypeOf(n);if(null===t)return !0;var r=Object.hasOwnProperty.call(t,"constructor")&&t.constructor;return r===Object||"function"==typeof r&&Function.toString.call(r)===Z}(n)||Array.isArray(n)||!!n[L]||!!n.constructor[L]||s(n)||v(n))}function i(n,t,r){void 0===r&&(r=!1),0===o(n)?(r?Object.keys:nn)(n).forEach((function(e){r&&"symbol"==typeof e||t(e,n[e],n);})):n.forEach((function(r,e){return t(e,r,n)}));}function o(n){var t=n[Q];return t?t.i>3?t.i-4:t.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,t){return 2===o(n)?n.has(t):Object.prototype.hasOwnProperty.call(n,t)}function a(n,t){return 2===o(n)?n.get(t):n[t]}function f(n,t,r){var e=o(n);2===e?n.set(t,r):3===e?(n.delete(t),n.add(r)):n[t]=r;}function c(n,t){return n===t?0!==n||1/n==1/t:n!=n&&t!=t}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var t=tn(n);delete t[Q];for(var r=nn(t),e=0;e<r.length;e++){var i=r[e],o=t[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(t[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]});}return Object.create(Object.getPrototypeOf(n),t)}function d(n,e){return void 0===e&&(e=!1),y(n)||t(n)||!r(n)?n:(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,t){return d(t,!0)}),!0),n)}function h(){n(2);}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(t){var r=rn[t];return r||n(18,t),r}function _(){return "production"===process.env.NODE_ENV||U||n(0),U}function j(n,t){t&&(b("Patches"),n.u=[],n.s=[],n.v=t);}function O(n){g(n),n.p.forEach(S),n.p=null;}function g(n){n===U&&(U=n.l);}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var t=n[Q];0===t.i||1===t.i?t.j():t.O=!0;}function P(t,e){e._=e.p.length;var i=e.p[0],o=void 0!==t&&t!==i;return e.h.g||b("ES5").S(e,t,o),o?(i[Q].P&&(O(e),n(4)),r(t)&&(t=M(e,t),e.l||x(e,t)),e.u&&b("Patches").M(i[Q],t,e.u,e.s)):t=M(e,i,[]),O(e),e.u&&e.v(e.u,e.s),t!==H?t:void 0}function M(n,t,r){if(y(t))return t;var e=t[Q];if(!e)return i(t,(function(i,o){return A(n,e,t,i,o,r)}),!0),t;if(e.A!==n)return t;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o;i(3===e.i?new Set(o):o,(function(t,i){return A(n,e,o,t,i,r)})),x(n,o,!1),r&&n.u&&b("Patches").R(e,r,n.u,n.s);}return e.o}function A(e,i,o,a,c,s){if("production"!==process.env.NODE_ENV&&c===o&&n(5),t(c)){var v=M(e,c,s&&i&&3!==i.i&&!u(i.D,a)?s.concat(a):void 0);if(f(o,a,v),!t(v))return;e.m=!1;}if(r(c)&&!y(c)){if(!e.h.F&&e._<1)return;M(e,c),i&&i.A.l||x(e,c);}}function x(n,t,r){void 0===r&&(r=!1),n.h.F&&n.m&&d(t,r);}function z(n,t){var r=n[Q];return (r?p(r):n)[t]}function I(n,t){if(t in n)for(var r=Object.getPrototypeOf(n);r;){var e=Object.getOwnPropertyDescriptor(r,t);if(e)return e;r=Object.getPrototypeOf(r);}}function k(n){n.P||(n.P=!0,n.l&&k(n.l));}function E(n){n.o||(n.o=l(n.t));}function R(n,t,r){var e=s(t)?b("MapSet").N(t,r):v(t)?b("MapSet").T(t,r):n.g?function(n,t){var r=Array.isArray(n),e={i:r?1:0,A:t?t.A:_(),P:!1,I:!1,D:{},l:t,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;r&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(t,r):b("ES5").J(t,r);return (r?r.A:_()).p.push(e),e}function D(e){return t(e)||n(22,e),function n(t){if(!r(t))return t;var e,u=t[Q],c=o(t);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=F(t,c),u.I=!1;}else e=F(t,c);return i(e,(function(t,r){u&&a(u.t,t)===r||f(e,t,n(r));})),3===c?new Set(e):e}(e)}function F(n,t){switch(t){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function K(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return "Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return "Unsupported patch operation: "+n},18:function(n){return "The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return "'current' expects a draft, got: "+n},23:function(n){return "'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,tn=Object.getOwnPropertyDescriptors||function(n){var t={};return nn(n).forEach((function(r){t[r]=Object.getOwnPropertyDescriptor(n,r);})),t},rn={},en={get:function(n,t){if(t===Q)return n;var e=p(n);if(!u(e,t))return function(n,t,r){var e,i=I(t,r);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,t);var i=e[t];return n.I||!r(i)?i:i===z(n.t,t)?(E(n),n.o[t]=R(n.A.h,i,n)):i},has:function(n,t){return t in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,t,r){var e=I(p(n),t);if(null==e?void 0:e.set)return e.set.call(n.k,r),!0;if(!n.P){var i=z(p(n),t),o=null==i?void 0:i[Q];if(o&&o.t===r)return n.o[t]=r,n.D[t]=!1,!0;if(c(r,i)&&(void 0!==r||u(n.t,t)))return !0;E(n),k(n);}return n.o[t]===r&&"number"!=typeof r&&(void 0!==r||t in n.o)||(n.o[t]=r,n.D[t]=!0,!0)},deleteProperty:function(n,t){return void 0!==z(n.t,t)||t in n.t?(n.D[t]=!1,E(n),k(n)):delete n.D[t],n.o&&delete n.o[t],!0},getOwnPropertyDescriptor:function(n,t){var r=p(n),e=Reflect.getOwnPropertyDescriptor(r,t);return e?{writable:!0,configurable:1!==n.i||"length"!==t,enumerable:e.enumerable,value:r[t]}:e},defineProperty:function(){n(11);},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12);}},on={};i(en,(function(n,t){on[n]=function(){return arguments[0]=arguments[0][0],t.apply(this,arguments)};})),on.deleteProperty=function(t,r){return "production"!==process.env.NODE_ENV&&isNaN(parseInt(r))&&n(13),en.deleteProperty.call(this,t[0],r)},on.set=function(t,r,e){return "production"!==process.env.NODE_ENV&&"length"!==r&&isNaN(parseInt(r))&&n(14),en.set.call(this,t[0],r,e,t[0])};var un=function(){function e(t){var e=this;this.g=B,this.F=!0,this.produce=function(t,i,o){if("function"==typeof t&&"function"!=typeof i){var u=i;i=t;var a=e;return function(n){var t=this;void 0===n&&(n=u);for(var r=arguments.length,e=Array(r>1?r-1:0),o=1;o<r;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var r;return (r=i).call.apply(r,[t,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),r(t)){var c=w(e),s=R(e,t,void 0),v=!0;try{f=i(s),v=!1;}finally{v?O(c):g(c);}return "undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw O(c),n})):(j(c,o),P(f,c))}if(!t||"object"!=typeof t){if((f=i(t))===H)return;return void 0===f&&(f=t),e.F&&d(f,!0),f}n(21,t);},this.produceWithPatches=function(n,t){return "function"==typeof n?function(t){for(var r=arguments.length,i=Array(r>1?r-1:0),o=1;o<r;o++)i[o-1]=arguments[o];return e.produceWithPatches(t,(function(t){return n.apply(void 0,[t].concat(i))}))}:[e.produce(n,t,(function(n,t){r=n,i=t;})),r,i];var r,i;},"boolean"==typeof(null==t?void 0:t.useProxies)&&this.setUseProxies(t.useProxies),"boolean"==typeof(null==t?void 0:t.autoFreeze)&&this.setAutoFreeze(t.autoFreeze);}var i=e.prototype;return i.createDraft=function(e){r(e)||n(8),t(e)&&(e=D(e));var i=w(this),o=R(this,e,void 0);return o[Q].C=!0,g(i),o},i.finishDraft=function(t,r){var e=t&&t[Q];"production"!==process.env.NODE_ENV&&(e&&e.C||n(9),e.I&&n(10));var i=e.A;return j(i,r),P(void 0,i)},i.setAutoFreeze=function(n){this.F=n;},i.setUseProxies=function(t){t&&!B&&n(20),this.g=t;},i.applyPatches=function(n,r){var e;for(e=r.length-1;e>=0;e--){var i=r[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}var o=b("Patches").$;return t(n)?o(n,r):this.produce(n,(function(n){return o(n,r.slice(e+1))}))},e}(),an=new un,fn=an.produce;an.produceWithPatches.bind(an);an.setAutoFreeze.bind(an);an.setUseProxies.bind(an);an.applyPatches.bind(an);an.createDraft.bind(an);an.finishDraft.bind(an);var produce = fn;

function bucketsInit() { }
function bucketsMoveNext(buckets, currIndex) {
    return produce(buckets, (draft) => {
        draft[currIndex].active = false;
        draft[currIndex].submitted = true;
        if (currIndex < buckets.length - 1) {
            draft[currIndex + 1].active = true;
            draft[currIndex + 1].values = draft[currIndex].values.filter((val) => !val.selected);
        }
        draft[currIndex].values = draft[currIndex].values.filter((val) => val.selected);
    });
}
function bucketsMovePrev(buckets, currIndex) {
    return produce(buckets, (draft) => {
        draft[currIndex].active = false;
        draft[currIndex].submitted = false;
        if (currIndex > 0) {
            draft[currIndex - 1].active = true;
            draft[currIndex - 1].submitted = false;
            for (const val of draft[currIndex].values) {
                val.selected = false;
            }
            draft[currIndex - 1].values = [...draft[currIndex - 1].values, ...draft[currIndex].values];
        }
        draft[currIndex].values = [];
    });
}
function bucketsCountSelected(buckets, currIndex) {
    return buckets[currIndex].values.reduce((acc, val) => acc + (val.selected ? 1 : 0), 0);
}

function CascadingBucketsView({ data, errors, renderValue, onChange: onChangeExternal, }) {
    return (jsxs(Fragment, { children: [Object.entries(data).map(([id, bucket]) => (jsx(Fragment$1, { children: bucket.active && (jsx(Box$2, { children: jsx(CascadingBucketsPane, { bucket: bucket, error: errors && errors[bucket.id], readOnly: bucket.readOnly, renderValue: renderValue, onChange: bucket.readOnly
                            ? () => __awaiter(this, void 0, void 0, function* () { return data; })
                            : (newBucket) => __awaiter(this, void 0, void 0, function* () {
                                const newBucketSet = produce(data, (draft) => {
                                    const index = draft.findIndex((bucket) => bucket.id === newBucket.id);
                                    draft.splice(index, 1, K(newBucket));
                                });
                                onChangeExternal(newBucketSet);
                            }) }, void 0) }, void 0)) }, id))),
            Object.entries(data).map(([id, bucket]) => (jsx(Fragment$1, { children: bucket.submitted && (jsx(Box$2, { children: jsx(CascadingBucketsPane, { bucket: bucket, renderValue: renderValue, readOnly: true, onChange: () => { } }, void 0) }, void 0)) }, id)))] }, void 0));
}

function CascadingBuckets({ data, renderValue, defaultBucket, onChange: onChangeExternal, renderControls, }) {
    var _a, _b;
    const [currIndex, setCurrIndex] = useState(defaultBucket);
    const currBucket = useMemo(() => data[currIndex], [currIndex, data]);
    const currSelected = useMemo(() => currBucket.values.reduce((acc, val) => acc + (val.selected ? 1 : 0), 0), [
        currBucket,
    ]);
    return (jsxs(Fragment, { children: [jsx(CascadingBucketsView, { data: data, renderValue: renderValue, onChange: onChangeExternal }, void 0),
            renderControls && (jsx(Box$2, { children: renderControls({
                    currIndex,
                    prevDisabled: currIndex === 0,
                    nextDisabled: currIndex === Object.keys(data).length - 1 ||
                        currSelected < ((_a = currBucket.min) !== null && _a !== void 0 ? _a : 1) ||
                        currSelected > ((_b = currBucket.max) !== null && _b !== void 0 ? _b : 3),
                    prev: () => {
                        const newBuckets = bucketsMovePrev(data, currIndex);
                        setCurrIndex((index) => index - 1);
                        return newBuckets;
                    },
                    next: () => {
                        const newBuckets = bucketsMoveNext(data, currIndex);
                        setCurrIndex((index) => index + 1);
                        return newBuckets;
                    },
                }) }, void 0))] }, void 0));
}

const ProfileHeader = styled$3('div')(({ theme }) => ({
    fontSize: '25px',
    fontWeight: 700,
    color: theme.palette.text.primary,
    margin: 0,
}));

function CascadingBucketsPane({ bucket, error, renderValue, readOnly = false, onChange: onChangeExternal, }) {
    return (jsxs(Fragment, { children: [jsx(ProfileHeader, { children: bucket.title }, void 0),
            bucket.instructions && !readOnly && jsx(Box$2, Object.assign({ mt: 2 }, { children: bucket.instructions }), void 0),
            jsx(Box$2, Object.assign({ mt: 2, mb: 2 }, { children: bucket.values.map((val, index) => (jsx(React__default.Fragment, { children: renderValue({
                        val,
                        readOnly,
                        onChange: (newVal) => {
                            const newBucket = produce(bucket, (draft) => {
                                draft.values.splice(index, 1, K(newVal));
                            });
                            onChangeExternal(newBucket);
                        },
                    }) }, index))) }), void 0),
            error && (jsx(Box$2, Object.assign({ mb: 2 }, { children: jsx(TextError, { children: error }, void 0) }), void 0))] }, void 0));
}

const TextError = styled$3('div')({
    marginLeft: '14px',
    marginRight: '14px',
    color: '#f44336',
    fontSize: '12px',
    marginTop: '3px',
    fontWeight: 400,
    lineHeight: '1.66',
    letterSpacing: '0.4px',
});

// This workaround allows us to run strict mode before MUI upgrades to v5.
const themeDataCommon = {
    shapeExtended: {
        borderRadius: [4, 6, 8],
    },
    typography: {
        fontFamily: '"Quicksand", sans-serif',
        h1: {
            fontWeight: 700,
            fontSize: '33px',
            lineHeight: 1,
            letterSpacing: 0,
        },
        h2: {
            fontWeight: 700,
            fontSize: '25px',
            lineHeight: 1.11,
        },
        h3: {
            fontWeight: 700,
            fontSize: '18px',
            lineHeight: 1.2,
        },
        h4: {
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: 1,
        },
        h5: {
            fontWeight: 700,
            fontSize: '15px',
            lineHeight: 1,
        },
        h6: {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: 1,
        },
        subtitle1: {
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: 1.4,
        },
        subtitle2: {
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: 1.4,
        },
        body1: {
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: 1.4,
        },
        body2: {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: 1.33,
        },
        button: {
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: 1,
        },
        caption: {
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: 1,
        },
        overline: {
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: 1,
        },
    },
};
Object.assign(Object.assign({}, themeDataCommon), { palette: {
        type: 'light',
        primary: {
            light: '#A560FF',
            main: '#6B2EF5',
            dark: '#2F0B96',
        },
        secondary: {
            light: '#D7FF00',
            main: '#CEDC00',
            dark: '#A4AF1A',
        },
        text: {
            primary: '#1A0154',
            secondary: '#8C8AAC',
            disabled: '#C0C0C0',
            hint: '#BAB3CC',
        },
        divider: '#F0F0F4',
        background: {
            default: '#ffffff',
            paper: '#FCFBFA',
        },
        action: {
            disabledBackground: '#F0F0F4',
        },
        grey: {
            50: '#F8F6F3',
            100: '#EFECE6',
            200: '#D6D3CD',
            300: '#BCB9B4',
            400: '#A2A09A',
            500: '#89877F',
            600: '#716D67',
            700: '#57544D',
            800: '#3C3B33',
            900: '#242119',
        },
    }, paletteExtended: {
        background: {
            primary: '#efeeea',
            secondary: '#efeeea',
        },
    }, overrides: {
        MuiCssBaseline: {
            '@global': {
                a: {
                    color: 'inherit',
                    textDecoration: 'none',
                },
                // Remove increment arrows from number inputs by default
                'input[type=number]': {
                    '&::-webkit-inner-spin-button, &::-webkit-inner-spin-button': {
                        '-webkit-appearance': 'none',
                        '-moz-appearance': 'none',
                        appearance: 'none',
                        margin: 0,
                    },
                },
                '.MuiOutlinedInput-input:-webkit-autofill': {
                    '-webkit-box-shadow': '0 0 0 100px #ffffff inset !important',
                    '-webkit-text-fill-color': '#000000 !important',
                },
            },
        },
        MuiFormLabel: {
            root: {
                color: grey$1[500],
            },
        },
        MuiCheckbox: {
            root: {
                color: grey$1[500],
            },
        },
        MuiRadio: {
            root: {
                color: grey$1[500],
            },
        },
        MuiInputLabel: {
            root: {
                fontSize: 16,
            },
        },
        MuiAvatar: {
            colorDefault: {
                backgroundColor: '#F0F0F4',
            },
        },
    }, props: {
        MuiRadio: {
            color: 'primary',
        },
        MuiCheckbox: {
            color: 'primary',
        },
    } });
Object.assign(Object.assign({}, themeDataCommon), { palette: {
        type: 'dark',
        primary: {
            light: '#D7B6F8',
            main: '#D7FF00',
            dark: '#D7FF00', // TBD: get from designers
        },
        secondary: {
            light: '#D7FF00',
            main: '#CEDC00',
            dark: '#A4AF1A',
        },
        text: {
            primary: '#FFFFFF',
            secondary: '#8C8AAC',
        },
        background: {
            default: '#2F0B96',
        },
        action: {
            disabledBackground: '#93A345',
        },
    }, paletteExtended: {
        background: {
            primary: '#efeeea',
            secondary: '#efeeea',
        },
    }, overrides: {
        MuiFormLabel: {
            root: {
                color: grey$1[500],
            },
        },
        MuiCheckbox: {
            root: {
                color: grey$1[500],
            },
        },
        MuiRadio: {
            root: {
                color: grey$1[500],
            },
        },
    }, props: {
        MuiRadio: {
            color: 'primary',
        },
    } });

const InitialThemeType = 'light';
const ThemeContext = createContext({
    type: InitialThemeType,
    toggle: () => { },
    setLight: () => { },
    setDark: () => { },
});

const useStyles = makeStyles$1((theme) => createStyles({
    container: {
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(43, 39, 97, 0.07)',
        borderRadius: '30px',
        padding: '5px 15px',
        cursor: 'pointer',
        userSelect: 'none',
        boxSizing: 'border-box',
        '&.dark': {
            background: 'rgba(212, 190, 75, 0.08)',
        },
        '&.checked': {
            background: '#692BF0',
            color: theme.palette.common.white,
            cursor: 'initial',
        },
        '&.dark.checked': {
            background: '#692BF0',
            color: theme.palette.common.white,
            cursor: 'initial',
        },
        // TODO: add readOnly for dark theme
        '&.readOnly': {
            background: theme.palette.common.white,
            color: 'inherit',
            cursor: 'initial',
            border: '1px solid #eeeeee',
        },
    },
    icon: {
        color: 'inherit',
        maxHeight: 15,
        marginRight: 11,
        '& svg': {
            fill: theme.palette.common.white,
        },
    },
}));
function Chip({ option: { label, icon }, checked, readOnly = false }) {
    const styles = useStyles();
    const { type } = useContext(ThemeContext);
    return (jsxs(Box$2, Object.assign({ className: clsx(styles.container, checked && 'checked', type === 'dark' && 'dark', readOnly && 'readOnly') }, { children: [jsx(Icon, { iconRef: icon, className: styles.icon }, void 0),
            jsx(Typography, Object.assign({ variant: "body2", align: "center" }, { children: label }), void 0)] }), void 0));
}

export { ActionButton, AppLink, ButtonAcceptCR, ButtonDeleteCR, ButtonFullWidthSecondary, ButtonLarge, ButtonLargeSecondary, ButtonMedium, ButtonSmall, CascadingBuckets, CascadingBucketsPane, CascadingBucketsView, Chip, DividerSpaced, ErrorText, Icon, IconHeader, InputSelectRadioPills, InputToggle, LoadingIndicatorProvider, LoadingSpinner, MiniHeader, MiniSubHeader, PageTitle, PaginationBar, Popup, PopupAlign, PopupSize, PreviewText, PreviewTitle, ScrollContainer, SearchBox, SectionHeader, SnackbarStyled, SnackbarStyledProvider, Spacing, StandardText, StyledBoolButtonGroup, StyledButtonGroup, Subtitle1, SystemText, TextError, bucketsCountSelected, bucketsInit, bucketsMoveNext, bucketsMovePrev, defaultIcons, useIcon, useLoadingIndicator, usePopup, useSnackbar };
